import * as jr from "react";
import F, { createContext as Fr, useContext as kr, useEffect as bs, useMemo as Ar } from "react";
import { FlexContainer as E, NavResponsive as _s, elRowGap2 as Ss, elWFull as W, elColGap2 as ws, Text2XL as js, TextBase as We, ElPageHeaderSeparator as Fs, useMediaQuery as Le, elColGap8 as ks, elRowGap8 as As, elFlexJustifyBetween as Cs, TextSM as U, elRowGap3 as Cr, elPx9 as Es, Tile as Ts, elColGap4 as $t, TextXL as Vs, MainContainer as Os, elHFull as Ds, elColGap6 as Ns, elPy2 as At, elFlexShrink0 as $s, Label as rt, elPb3 as Rs, elPr3 as Is, elPx6 as Ls, InputGroup as _e, InputError as Rt, Nav as Ps, elColGap3 as Ms, TextL as Us, ButtonGroup as Er, Button as He, elPt0 as Bs, elPx7 as qs, elRowGap1 as Gs, elPy3 as Ws, InputWrap as ze, elMt6 as Hs, elRowGap4 as Ze, elMt3 as Tr, FormSectionDivider as zs, elHasBoldText as ir, elMt7 as Zs, TextArea as Xs, elFlex as Ys, elFlexWrap as Js } from "@reapit/elements";
import { useNavigate as Qs, Outlet as It, useParams as Ks } from "react-router";
import { elPy9 as Lt, elHFit as en, FormIcon as Vr, SelectAsync as Or, PersistentNotification as Pt, elUnorderedList as tn, FormSectionViewDivider as rn, LoadingSkeleton as sn, Select as nn, elMb4 as ar, InputFile as an } from "@reapitform/common-ui";
import { LoaderCards as Dr } from "@reapitform/ui-loader-activity";
import { usePlatformGet as Nr, usePlatformUpdate as $r, useAttachment as Rr } from "@reapitform/hooks";
import { ErrorBoundary as st, isValidUrl as ln, yup as oe, getTextRequiredFieldIndicator as ve, strictInput as on } from "@reapitform/utils";
import { queryClient as un } from "@reapitform/core";
function cn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ir = { exports: {} }, nt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dn = F, fn = Symbol.for("react.element"), hn = Symbol.for("react.fragment"), pn = Object.prototype.hasOwnProperty, mn = dn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, yn = { key: !0, ref: !0, __self: !0, __source: !0 };
function Lr(e, r, t) {
  var s, n = {}, i = null, a = null;
  t !== void 0 && (i = "" + t), r.key !== void 0 && (i = "" + r.key), r.ref !== void 0 && (a = r.ref);
  for (s in r) pn.call(r, s) && !yn.hasOwnProperty(s) && (n[s] = r[s]);
  if (e && e.defaultProps) for (s in r = e.defaultProps, r) n[s] === void 0 && (n[s] = r[s]);
  return { $$typeof: fn, type: e, key: i, ref: a, props: n, _owner: mn.current };
}
nt.Fragment = hn;
nt.jsx = Lr;
nt.jsxs = Lr;
Ir.exports = nt;
var o = Ir.exports;
const vl = () => {
  const e = Qs(), r = () => e("/dashboard");
  return /* @__PURE__ */ o.jsxs(E, { isFlexColumn: !0, children: [
    /* @__PURE__ */ o.jsx(
      _s,
      {
        avatarText: "JD",
        defaultNavIndex: 0,
        options: [
          {
            callback: r,
            itemIndex: 0
          }
        ]
      }
    ),
    /* @__PURE__ */ o.jsx(It, {})
  ] });
};
var xn = function() {
  const r = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, s = [];
  r.forEach((i) => {
    (i ? i.split(" ") : []).forEach((l) => {
      if (l.startsWith("atm_")) {
        const [, c] = l.split("_");
        t[c] = l;
      } else
        s.push(l);
    });
  });
  const n = [];
  for (const i in t)
    Object.prototype.hasOwnProperty.call(t, i) && n.push(t[i]);
  return n.push(...s), n.join(" ");
}, V = xn;
const gn = "l1lf6y3t", vn = ({
  pageDescription: e,
  pageTitle: r,
  badge: t
}) => {
  if (!e && !r && !t) return;
  const s = !!(r || t);
  return /* @__PURE__ */ o.jsxs(E, {
    isFlexColumn: !0,
    isFlexShrink0: !0,
    hasGreyBackground: !0,
    className: V(Lt, Ss, W, en, gn),
    children: [s && /* @__PURE__ */ o.jsxs(E, {
      hasMaxWidth: !0,
      isFlexRow: !0,
      isFlexAlignCenter: !0,
      className: V(ws, W),
      children: [/* @__PURE__ */ o.jsx(js, {
        hasBoldText: !0,
        children: r
      }, "page-title"), t]
    }, "page-title-container"), e && /* @__PURE__ */ o.jsx(E, {
      hasMaxWidth: !0,
      className: V(W),
      children: typeof e == "string" ? /* @__PURE__ */ o.jsx(We, {
        children: e
      }) : e?.map((n, i) => /* @__PURE__ */ o.jsxs(o.Fragment, {
        children: [i > 0 && /* @__PURE__ */ o.jsx(Fs, {}), /* @__PURE__ */ o.jsx(We, {
          children: n
        }, i)]
      }))
    }, "page-description-container")]
  });
}, bn = ({ children: e, ...r }) => {
  const { isMobile: t, isTablet: s } = Le(), n = t || s;
  return /* @__PURE__ */ o.jsx(
    E,
    {
      hasMaxWidth: !0,
      isFlexColumn: n,
      isFlexGrow1: !0,
      isFlexColumnReverse: n,
      className: V(Lt, ks, As, Cs, W),
      ...r,
      children: e
    }
  );
}, bl = ({
  iconName: e,
  title: r,
  description: t
}) => {
  const {
    isMobile: s,
    isTablet: n
  } = Le(), i = s || n;
  return /* @__PURE__ */ o.jsxs(E, {
    isFlexColumn: !0,
    isFlexGrow1: i,
    className: V(Cr, "c1dng9gw"),
    children: [/* @__PURE__ */ o.jsx(Vr, {
      iconName: e
    }), /* @__PURE__ */ o.jsxs(E, {
      isFlexColumn: !0,
      children: [/* @__PURE__ */ o.jsx(We, {
        hasBoldText: !0,
        hasMargin: !0,
        children: r
      }), /* @__PURE__ */ o.jsx(U, {
        children: t
      })]
    })]
  });
};
function _n(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Sn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, ft = /* @__PURE__ */ _n(
  function(e) {
    return Sn.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), wn = (e) => e.toUpperCase() === e, jn = (e) => (r) => e.indexOf(r) === -1, Pr = (e, r) => {
  const t = {};
  return Object.keys(e).filter(jn(r)).forEach((s) => {
    t[s] = e[s];
  }), t;
};
function Fn(e, r, t) {
  const s = Pr(r, t);
  if (!e) {
    const n = typeof ft == "function" ? { default: ft } : ft;
    Object.keys(s).forEach((i) => {
      n.default(i) || delete s[i];
    });
  }
  return s;
}
var kn = (e, r) => {
};
function An(e) {
  let r = "";
  return (t) => {
    const s = (i, a) => {
      const { as: l = e, class: c = r } = i, m = t.propsAsIs === void 0 ? !(typeof l == "string" && l.indexOf("-") === -1 && !wn(l[0])) : t.propsAsIs, h = Fn(m, i, [
        "as",
        "class"
      ]);
      h.ref = a, h.className = t.atomic ? V(t.class, h.className || c) : V(h.className || c, t.class);
      const { vars: y } = t;
      if (y) {
        const f = {};
        for (const $ in y) {
          const D = y[$], I = D[0], A = D[1] || "", X = typeof I == "function" ? I(i) : I;
          kn(X, t.name), f[`--${$}`] = `${X}${A}`;
        }
        const S = h.style || {}, w = Object.keys(S);
        w.length > 0 && w.forEach(($) => {
          f[$] = S[$];
        }), h.style = f;
      }
      return e.__wyw_meta && e !== l ? (h.as = l, F.createElement(e, h)) : F.createElement(l, h);
    }, n = F.forwardRef ? F.forwardRef(s) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (i) => {
        const a = Pr(i, ["innerRef"]);
        return s(a, i.innerRef);
      }
    );
    return n.displayName = t.name, n.__wyw_meta = {
      className: t.class || r,
      extends: e
    }, n;
  };
}
var ae = An;
const Cn = ({
  children: e,
  ...r
}) => (delete r.isFullWidth, /* @__PURE__ */ o.jsx(E, {
  ...r,
  children: e
})), En = () => Cn, Tn = () => (e) => e.isFullWidth ? "100%" : "320px", Vn = /* @__PURE__ */ ae(En())({
  name: "PageInformationContainer",
  class: "p1j6hgkh",
  propsAsIs: !0,
  vars: {
    "p1j6hgkh-0": [Tn()]
  }
}), On = () => (e) => e.isVertical ? "2px" : "100%", Dn = () => (e) => e.isVertical ? "100%" : "2px", Nn = /* @__PURE__ */ ae("span")({
  name: "Divider",
  class: "d1wiu2kb",
  propsAsIs: !1,
  vars: {
    "d1wiu2kb-0": [On()],
    "d1wiu2kb-1": [Dn()]
  }
}), _l = () => {
  const {
    isMobile: e,
    isTablet: r
  } = Le(), t = e || r;
  return /* @__PURE__ */ o.jsx(Nn, {
    isVertical: t
  });
}, Sl = ({
  children: e,
  className: r,
  ...t
}) => {
  const {
    isMobile: s,
    isTablet: n
  } = Le(), i = s || n;
  return /* @__PURE__ */ o.jsx(Vn, {
    isFlexRow: i,
    isFlexColumn: !i,
    isFlexWrap: !0,
    isFlexGrow1: !0,
    isFullWidth: i,
    className: V(!i && Es, r),
    ...t,
    children: e
  });
}, wl = ({
  children: e,
  className: r,
  ...t
}) => /* @__PURE__ */ o.jsx(E, { isFlexGrow1: !0, isFlexColumn: !0, className: V(Cr, W, r), tag: "section", ...t, children: e }), $n = "p55oprk", jl = ({
  children: e,
  pageTitle: r,
  pageDescription: t,
  hasBodyGrayBackground: s,
  badge: n,
  withoutBodyContiner: i,
  className: a,
  id: l
}) => /* @__PURE__ */ o.jsxs(E, {
  id: l,
  isFlexWrap: !0,
  hasGreyBackground: s,
  className: V($n, a),
  children: [/* @__PURE__ */ o.jsx(vn, {
    badge: n,
    pageDescription: t,
    pageTitle: r
  }), !i && /* @__PURE__ */ o.jsx(bn, {
    children: e
  }), i && e]
}), Rn = () => E, In = /* @__PURE__ */ ae(Rn())({
  name: "SectionTileHeader",
  class: "s1p8wgtc",
  propsAsIs: !0
}), Ln = () => Ts, Pn = /* @__PURE__ */ ae(Ln())({
  name: "SectionTileContainer",
  class: "s1wxr6ff",
  propsAsIs: !0
}), Mn = "s14mlw6o", Un = ({
  title: e,
  children: r,
  actionTitle: t,
  onActionClick: s,
  iconName: n,
  disableMarginBottom: i
}) => {
  const a = (l) => {
    l.preventDefault(), s?.();
  };
  return /* @__PURE__ */ o.jsxs(Pn, {
    className: V(Mn, i && "c1v6nded"),
    children: [/* @__PURE__ */ o.jsxs(In, {
      isFlexJustifyBetween: !0,
      isFlexAlignCenter: !0,
      children: [/* @__PURE__ */ o.jsxs(E, {
        isFlexAlignCenter: !0,
        className: $t,
        children: [n && /* @__PURE__ */ o.jsx(Vr, {
          iconName: n
        }), /* @__PURE__ */ o.jsx(Vs, {
          hasBoldText: !0,
          children: e
        })]
      }), t && /* @__PURE__ */ o.jsx("a", {
        onClick: a,
        children: /* @__PURE__ */ o.jsx(U, {
          intent: "primary",
          children: t
        })
      })]
    }), r]
  });
}, Bn = "enx1tnn", Fl = () => /* @__PURE__ */ o.jsx(Os, { hasGreyBackground: !0, className: V(Ds, Bn), children: /* @__PURE__ */ o.jsx(It, {}) }), qn = ({
  title: e,
  children: r,
  className: t,
  isEmpty: s
}) => {
  const n = typeof r == "string", {
    isMobile: i
  } = Le();
  return /* @__PURE__ */ o.jsxs(E, {
    isFlexColumn: i,
    className: V(Ns, At, t),
    children: [/* @__PURE__ */ o.jsx(U, {
      hasGreyText: !0,
      className: V($s, "cah2twj"),
      children: e
    }), s && /* @__PURE__ */ o.jsx(U, {
      hasGreyText: !0,
      children: "Not Provided"
    }), n && !s && /* @__PURE__ */ o.jsx(U, {
      children: r
    }), !n && !s && r]
  });
}, Gn = "d1itptyp", Mr = ({
  value: e
}) => /* @__PURE__ */ o.jsx("p", {
  className: Gn,
  children: e
}), kl = ({ value: e = "", label: r, className: t }) => /* @__PURE__ */ o.jsxs(E, { isFlexColumn: !0, children: [
  /* @__PURE__ */ o.jsx(rt, { className: V(Rs, Is), children: r }),
  /* @__PURE__ */ o.jsx(E, { hasGreyBackground: !0, isFlexAlignCenter: !0, isFlexJustifyCenter: !0, className: V(Lt, Ls, t), children: /* @__PURE__ */ o.jsx(Mr, { value: e }) })
] }), Al = ({ errorMessage: e, label: r, keyValue: t, ...s }) => /* @__PURE__ */ o.jsxs(_e, { children: [
  r && /* @__PURE__ */ o.jsx(rt, { children: r }),
  /* @__PURE__ */ o.jsx(
    Or,
    {
      apiPath: "api/Utilities/Countries",
      getOptionValue: (n) => String(t ? n[t] : n.displayName),
      getOptionLabel: (n) => n.displayName,
      hasError: !!e,
      ...s
    }
  ),
  e && /* @__PURE__ */ o.jsx(Rt, { message: e })
] }), Cl = ({ country: e, errorMessage: r, keyValue: t, label: s, ...n }) => /* @__PURE__ */ o.jsxs(_e, { children: [
  s && /* @__PURE__ */ o.jsx(rt, { children: s }),
  /* @__PURE__ */ o.jsx(
    Or,
    {
      apiPath: `api/Utilities/Regions/${e ?? ""}`,
      getOptionValue: (i) => String(t ? i[t] : i.displayName),
      getOptionLabel: (i) => i.displayName,
      hasError: !!r,
      ...n
    }
  ),
  r && /* @__PURE__ */ o.jsx(Rt, { message: r })
] }), Wn = "e1pvud03", Hn = "e1fxw76m", zn = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14.4744%202L19.2785%205.14371V12L24.1125%208.76645V2H14.4744Z'%20fill='%2398C1C2'/%3e%3cpath%20d='M9.63727%2012L14.4413%2015.1437V22L19.2754%2018.7665V12H9.63727Z'%20fill='%23D1263D'/%3e%3cpath%20d='M0%205.2334L4.80404%208.3771V15.2334L9.63809%2011.9999V5.2334H0Z'%20fill='%23FD9E1D'/%3e%3c/svg%3e", Zn = "l1uobq1p", El = ({
  title: e = "Reapit Form",
  exitBtnText: r = "Exit",
  actionButtons: t,
  onExit: s
}) => /* @__PURE__ */ o.jsxs(o.Fragment, {
  children: [/* @__PURE__ */ o.jsx(E, {
    isFlexColumn: !0,
    className: V(Bs, Wn),
    children: /* @__PURE__ */ o.jsx(Ps, {
      className: V(qs),
      children: /* @__PURE__ */ o.jsxs(E, {
        isFlexJustifyBetween: !0,
        className: V(Hn, W),
        children: [/* @__PURE__ */ o.jsxs(E, {
          isFlexRow: !0,
          isFlexAlignCenter: !0,
          className: Ms,
          children: [/* @__PURE__ */ o.jsx("img", {
            src: zn,
            alt: "ReapitForm",
            className: Zn
          }), /* @__PURE__ */ o.jsx(Us, {
            hasBoldText: !0,
            className: "c1d0rifq",
            children: e
          })]
        }), /* @__PURE__ */ o.jsxs(Er, {
          children: [/* @__PURE__ */ o.jsx(He, {
            onClick: s,
            children: r
          }), t]
        })]
      })
    })
  }), /* @__PURE__ */ o.jsx(It, {})]
}), Ur = Fr(null), Xn = () => kr(Ur), Yn = ({
  onLoaded: e,
  ...r
}) => {
  const [t, s, n] = Nr({
    path: `/api/User/${r.documentId}/Card?cardNum=${r.id}`,
    headers: {},
    retry: !1
  });
  return F.useEffect(() => {
    s || n || t && e?.(t);
  }, [s, n]), /* @__PURE__ */ o.jsxs(Ur.Provider, { value: t || [], children: [
    /* @__PURE__ */ o.jsx(Dr, { isShow: s }),
    !s && r.children
  ] });
}, Jn = ({
  validationSchema: e,
  value: r,
  errorCount: t
}) => {
  const [s, n] = F.useState(t ?? 0);
  return F.useEffect(() => {
    e && (n(0), e.validate(r, {
      abortEarly: !1
    }).catch((i) => n(i.inner.length)));
  }, [r]), s ? /* @__PURE__ */ o.jsxs(Pt, {
    icon: "warning",
    intent: "warning",
    isExpanded: !0,
    isInline: !0,
    className: "cehgy2d",
    children: ["There ", s > 1 ? "are" : "is", " ", s, " mandatory field that requires completion."]
  }) : null;
}, Qn = ({
  changeRequested: e
}) => {
  const r = e?.length ?? 0;
  if (!r) return null;
  const t = r > 1;
  return /* @__PURE__ */ o.jsxs(Pt, {
    icon: "warning",
    intent: "warning",
    isExpanded: !0,
    isInline: !0,
    className: "chan1lc",
    children: ["There ", t ? "are" : "is", " ", r, " ", t ? "change requests" : "change request", " that requires resolution."]
  });
}, Kn = ({ changeRequested: e }) => {
  const [r, t] = $r({
    path: `/api/Recipient/ChangeRequest/${e.id}/Resolve`,
    method: "PATCH",
    errorMessage: `Failed to resolved change request from ${e.fullName}`,
    successMessage: `Successfully resolved the change request from ${e.fullName}`
  });
  return /* @__PURE__ */ o.jsx(Pt, { intent: "default", isExpanded: !0, isInline: !0, className: ei, children: /* @__PURE__ */ o.jsxs(E, { isFlexNoWrap: !0, isFlexJustifyBetween: !0, className: V($t), children: [
    /* @__PURE__ */ o.jsxs(E, { isFlexColumn: !0, className: Gs, children: [
      /* @__PURE__ */ o.jsxs(U, { children: [
        "Change requested by ",
        e?.fullName,
        ":"
      ] }),
      /* @__PURE__ */ o.jsx(E, { isFlexColumn: !0, children: e?.changesRequested.map((s, n) => /* @__PURE__ */ o.jsx(
        E,
        {
          isFlexAlignStart: !0,
          className: tn,
          children: /* @__PURE__ */ o.jsx(U, { children: s })
        },
        `${e.id}-${n}`
      )) })
    ] }),
    /* @__PURE__ */ o.jsx(
      He,
      {
        disabled: t,
        loading: t,
        onClick: () => r(void 0),
        intent: "neutral",
        children: "Resolve"
      }
    )
  ] }) });
}, ei = "change-request-list-item", ti = "cusjmzy", ri = ({
  className: e,
  changesRequested: r = []
}) => /* @__PURE__ */ o.jsx(E, {
  isFlexColumn: !0,
  className: V(ti, Ws, e),
  children: r.map((t) => /* @__PURE__ */ o.jsx(Kn, {
    changeRequested: t
  }, t.id))
}), si = ({
  data: e
}) => /* @__PURE__ */ o.jsx(E, {
  isFlexColumn: !0,
  children: e.map((r, t) => /* @__PURE__ */ o.jsx(U, {
    children: r
  }, t))
}), ni = ({
  fileId: e
}) => {
  const [r, t] = F.useState(), [s, n] = F.useState(!0), {
    downloadFileBlob: i
  } = Rr();
  return bs(() => {
    i(e).then((a) => {
      const l = URL.createObjectURL(a);
      t(l);
    }).catch(() => {
      t(void 0);
    }).finally(() => {
      n(!1);
    });
  }, [e]), s ? /* @__PURE__ */ o.jsx(sn, {
    width: "100%",
    height: "36px"
  }) : r ? /* @__PURE__ */ o.jsx("img", {
    src: r,
    className: "c14ug1mc"
  }) : /* @__PURE__ */ o.jsx(U, {
    hasGreyText: !0,
    children: "Failed to load image"
  });
}, ii = ({
  data: e
}) => /* @__PURE__ */ o.jsx(E, {
  isFlexColumn: !0,
  className: W,
  children: e.map((r, t) => /* @__PURE__ */ o.jsx(ni, {
    fileId: r
  }, t))
}), ai = ({
  data: e
}) => ln(e) ? /* @__PURE__ */ o.jsx("img", {
  src: e,
  className: "coyhnib"
}) : /* @__PURE__ */ o.jsx(Mr, {
  value: e
}), li = (e) => {
  if (!!!(Array.isArray(e.data) ? e.data.length : e.data)) return /* @__PURE__ */ o.jsx(U, {
    hasGreyText: !0,
    children: "Not Provided"
  });
  switch (e.dataType) {
    case "Text":
      return /* @__PURE__ */ o.jsx(si, {
        data: e.data
      });
    case "Image":
      return /* @__PURE__ */ o.jsx(ai, {
        data: e.data
      });
    case "FileAttachment":
      return /* @__PURE__ */ o.jsx(ii, {
        data: e.data
      });
    default:
      return /* @__PURE__ */ o.jsx(U, {
        children: e.data
      });
  }
}, oi = (e) => /* @__PURE__ */ o.jsx(qn, {
  title: e.title,
  children: /* @__PURE__ */ o.jsx(li, {
    ...e
  })
}), ui = (e) => {
  const r = !!e.fields.length;
  return /* @__PURE__ */ o.jsxs(E, {
    isFlexColumn: !0,
    children: [e.title && /* @__PURE__ */ o.jsx(U, {
      hasBoldText: !0,
      className: At,
      children: e.title
    }), r && e.fields.map((t, s) => /* @__PURE__ */ o.jsx(oi, {
      ...t
    }, s)), !r && /* @__PURE__ */ o.jsx(U, {
      hasGreyText: !0,
      className: At,
      children: "Not Provided"
    })]
  });
}, ci = ({
  changeRequest: e
}) => {
  const r = Xn(), t = r?.reduce((s, n) => s + (n.emptyRequiredFields ?? 0), 0);
  return /* @__PURE__ */ o.jsxs(st, {
    children: [/* @__PURE__ */ o.jsx(Jn, {
      errorCount: t
    }), /* @__PURE__ */ o.jsx(Qn, {
      changeRequested: e
    }), /* @__PURE__ */ o.jsx(E, {
      isFlexColumn: !0,
      children: r?.map((s, n) => /* @__PURE__ */ o.jsxs(o.Fragment, {
        children: [/* @__PURE__ */ o.jsx(ui, {
          ...s
        }), s.title && n + 1 !== r.length && /* @__PURE__ */ o.jsx(rn, {})]
      }))
    })]
  });
}, di = ({ changeRequest: e, ...r }) => /* @__PURE__ */ o.jsx(st, { children: /* @__PURE__ */ o.jsx(Yn, { ...r, children: /* @__PURE__ */ o.jsx(ci, { changeRequest: e }) }) }), Xe = "unverified_files", fi = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  const n = { [r]: e.value || [] }, i = {
    [r]: oe.array(
      oe.object({
        defaultAttachmentFileID: oe.string().required("Please wait until all files are uploaded!").typeError("Please wait until all files are uploaded!")
      })
    ).applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (a) => a.min(1, t).required(t).typeError(t)
    )
  };
  return i[r] = i[r].minItems(e.config?.min).maxItems(e.config?.max), { defaultValue: n, validationSchema: i };
}, Br = Fr({
  data: null,
  saveForm: () => {
  }
}), hi = () => kr(Br), pi = (e) => {
  const [
    r,
    t,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    s,
    // eslint-disable-line no-unused-vars
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    n,
    // eslint-disable-line no-unused-vars
    i
  ] = Nr({
    path: `/api/User/${e.documentId}/Card/Edit?cardNum=${e.id}`,
    headers: {},
    retry: !1
  }), [a, l] = $r({
    path: `/api/User/${e.documentId}/Card/Edit?cardNum=${e.id}`,
    headers: {}
  }), { verifyFiles: c } = Rr({ errorMessage: "Failed to upload the files", disableReapitConnect: !0 }), m = async (h) => {
    const y = h[Xe];
    return y?.length && await c(y), delete h[Xe], a(h);
  };
  return /* @__PURE__ */ o.jsxs(
    Br.Provider,
    {
      value: {
        data: r || null,
        isSubmitting: l,
        saveForm: m,
        isLoading: t || i
      },
      children: [
        /* @__PURE__ */ o.jsx(Dr, { isShow: t || i }),
        !t && !i && e.children
      ]
    }
  );
};
var Pe = (e) => e.type === "checkbox", we = (e) => e instanceof Date, te = (e) => e == null;
const qr = (e) => typeof e == "object";
var q = (e) => !te(e) && !Array.isArray(e) && qr(e) && !we(e), mi = (e) => q(e) && e.target ? Pe(e.target) ? e.target.checked : e.target.value : e, yi = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, xi = (e, r) => e.has(yi(r)), gi = (e) => {
  const r = e.constructor && e.constructor.prototype;
  return q(r) && r.hasOwnProperty("isPrototypeOf");
}, Mt = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function J(e) {
  let r;
  const t = Array.isArray(e);
  if (e instanceof Date)
    r = new Date(e);
  else if (e instanceof Set)
    r = new Set(e);
  else if (!(Mt && (e instanceof Blob || e instanceof FileList)) && (t || q(e)))
    if (r = t ? [] : {}, !t && !gi(e))
      r = e;
    else
      for (const s in e)
        e.hasOwnProperty(s) && (r[s] = J(e[s]));
  else
    return e;
  return r;
}
var Me = (e) => Array.isArray(e) ? e.filter(Boolean) : [], P = (e) => e === void 0, v = (e, r, t) => {
  if (!r || !q(e))
    return t;
  const s = Me(r.split(/[,[\].]+?/)).reduce((n, i) => te(n) ? n : n[i], e);
  return P(s) || s === e ? P(e[r]) ? t : e[r] : s;
}, ce = (e) => typeof e == "boolean", Ut = (e) => /^\w*$/.test(e), Gr = (e) => Me(e.replace(/["|']|\]/g, "").split(/\.|\[/)), R = (e, r, t) => {
  let s = -1;
  const n = Ut(r) ? [r] : Gr(r), i = n.length, a = i - 1;
  for (; ++s < i; ) {
    const l = n[s];
    let c = t;
    if (s !== a) {
      const m = e[l];
      c = q(m) || Array.isArray(m) ? m : isNaN(+n[s + 1]) ? {} : [];
    }
    if (l === "__proto__")
      return;
    e[l] = c, e = e[l];
  }
  return e;
};
const lr = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ie = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, fe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Wr = F.createContext(null), ue = () => F.useContext(Wr), vi = (e) => {
  const { children: r, ...t } = e;
  return F.createElement(Wr.Provider, { value: t }, r);
};
var bi = (e, r, t, s = !0) => {
  const n = {
    defaultValues: r._defaultValues
  };
  for (const i in e)
    Object.defineProperty(n, i, {
      get: () => {
        const a = i;
        return r._proxyFormState[a] !== ie.all && (r._proxyFormState[a] = !s || ie.all), e[a];
      }
    });
  return n;
}, ee = (e) => q(e) && !Object.keys(e).length, _i = (e, r, t, s) => {
  t(e);
  const { name: n, ...i } = e;
  return ee(i) || Object.keys(i).length >= Object.keys(r).length || Object.keys(i).find((a) => r[a] === ie.all);
}, se = (e) => Array.isArray(e) ? e : [e];
function Hr(e) {
  const r = F.useRef(e);
  r.current = e, F.useEffect(() => {
    const t = !e.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
var de = (e) => typeof e == "string", Si = (e, r, t, s, n) => de(e) ? (s && r.watch.add(e), v(t, e, n)) : Array.isArray(e) ? e.map((i) => (s && r.watch.add(i), v(t, i))) : (s && (r.watchAll = !0), t), zr = (e, r, t, s, n) => r ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [s]: n || !0
  }
} : {}, xe = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    const t = (Math.random() * 16 + e) % 16 | 0;
    return (r == "x" ? t : t & 3 | 8).toString(16);
  });
}, ht = (e, r, t = {}) => t.shouldFocus || P(t.shouldFocus) ? t.focusName || `${e}.${P(t.focusIndex) ? r : t.focusIndex}.` : "", Ie = (e) => ({
  isOnSubmit: !e || e === ie.onSubmit,
  isOnBlur: e === ie.onBlur,
  isOnChange: e === ie.onChange,
  isOnAll: e === ie.all,
  isOnTouch: e === ie.onTouched
}), Ct = (e, r, t) => !t && (r.watchAll || r.watch.has(e) || [...r.watch].some((s) => e.startsWith(s) && /^\.\w+/.test(e.slice(s.length))));
const Ve = (e, r, t, s) => {
  for (const n of t || Object.keys(e)) {
    const i = v(e, n);
    if (i) {
      const { _f: a, ...l } = i;
      if (a) {
        if (a.refs && a.refs[0] && r(a.refs[0], n) && !s)
          return !0;
        if (a.ref && r(a.ref, a.name) && !s)
          return !0;
        if (Ve(l, r))
          break;
      } else if (q(l) && Ve(l, r))
        break;
    }
  }
};
var Zr = (e, r, t) => {
  const s = se(v(e, t));
  return R(s, "root", r[t]), R(e, t, s), e;
}, Bt = (e) => e.type === "file", me = (e) => typeof e == "function", Ye = (e) => {
  if (!Mt)
    return !1;
  const r = e ? e.ownerDocument : 0;
  return e instanceof (r && r.defaultView ? r.defaultView.HTMLElement : HTMLElement);
}, qe = (e) => de(e), qt = (e) => e.type === "radio", Je = (e) => e instanceof RegExp;
const or = {
  value: !1,
  isValid: !1
}, ur = { value: !0, isValid: !0 };
var Xr = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const r = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: r, isValid: !!r.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !P(e[0].attributes.value) ? P(e[0].value) || e[0].value === "" ? ur : { value: e[0].value, isValid: !0 } : ur
    ) : or;
  }
  return or;
};
const cr = {
  isValid: !1,
  value: null
};
var Yr = (e) => Array.isArray(e) ? e.reduce((r, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : r, cr) : cr;
function dr(e, r, t = "validate") {
  if (qe(e) || Array.isArray(e) && e.every(qe) || ce(e) && !e)
    return {
      type: t,
      message: qe(e) ? e : "",
      ref: r
    };
}
var Ce = (e) => q(e) && !Je(e) ? e : {
  value: e,
  message: ""
}, Et = async (e, r, t, s, n) => {
  const { ref: i, refs: a, required: l, maxLength: c, minLength: m, min: h, max: y, pattern: f, validate: S, name: w, valueAsNumber: $, mount: D, disabled: I } = e._f, A = v(r, w);
  if (!D || I)
    return {};
  const X = a ? a[0] : i, K = (C) => {
    s && X.reportValidity && (X.setCustomValidity(ce(C) ? "" : C || ""), X.reportValidity());
  }, _ = {}, j = qt(i), T = Pe(i), L = j || T, Y = ($ || Bt(i)) && P(i.value) && P(A) || Ye(i) && i.value === "" || A === "" || Array.isArray(A) && !A.length, H = zr.bind(null, w, t, _), M = (C, N, B, Q = fe.maxLength, le = fe.minLength) => {
    const ne = C ? N : B;
    _[w] = {
      type: C ? Q : le,
      message: ne,
      ref: i,
      ...H(C ? Q : le, ne)
    };
  };
  if (n ? !Array.isArray(A) || !A.length : l && (!L && (Y || te(A)) || ce(A) && !A || T && !Xr(a).isValid || j && !Yr(a).isValid)) {
    const { value: C, message: N } = qe(l) ? { value: !!l, message: l } : Ce(l);
    if (C && (_[w] = {
      type: fe.required,
      message: N,
      ref: X,
      ...H(fe.required, N)
    }, !t))
      return K(N), _;
  }
  if (!Y && (!te(h) || !te(y))) {
    let C, N;
    const B = Ce(y), Q = Ce(h);
    if (!te(A) && !isNaN(A)) {
      const le = i.valueAsNumber || A && +A;
      te(B.value) || (C = le > B.value), te(Q.value) || (N = le < Q.value);
    } else {
      const le = i.valueAsDate || new Date(A), ne = (Ne) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Ne), Oe = i.type == "time", De = i.type == "week";
      de(B.value) && A && (C = Oe ? ne(A) > ne(B.value) : De ? A > B.value : le > new Date(B.value)), de(Q.value) && A && (N = Oe ? ne(A) < ne(Q.value) : De ? A < Q.value : le < new Date(Q.value));
    }
    if ((C || N) && (M(!!C, B.message, Q.message, fe.max, fe.min), !t))
      return K(_[w].message), _;
  }
  if ((c || m) && !Y && (de(A) || n && Array.isArray(A))) {
    const C = Ce(c), N = Ce(m), B = !te(C.value) && A.length > +C.value, Q = !te(N.value) && A.length < +N.value;
    if ((B || Q) && (M(B, C.message, N.message), !t))
      return K(_[w].message), _;
  }
  if (f && !Y && de(A)) {
    const { value: C, message: N } = Ce(f);
    if (Je(C) && !A.match(C) && (_[w] = {
      type: fe.pattern,
      message: N,
      ref: i,
      ...H(fe.pattern, N)
    }, !t))
      return K(N), _;
  }
  if (S) {
    if (me(S)) {
      const C = await S(A, r), N = dr(C, X);
      if (N && (_[w] = {
        ...N,
        ...H(fe.validate, N.message)
      }, !t))
        return K(N.message), _;
    } else if (q(S)) {
      let C = {};
      for (const N in S) {
        if (!ee(C) && !t)
          break;
        const B = dr(await S[N](A, r), X, N);
        B && (C = {
          ...B,
          ...H(N, B.message)
        }, K(B.message), t && (_[w] = C));
      }
      if (!ee(C) && (_[w] = {
        ref: X,
        ...C
      }, !t))
        return _;
    }
  }
  return K(!0), _;
}, pt = (e, r) => [
  ...e,
  ...se(r)
], mt = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function yt(e, r, t) {
  return [
    ...e.slice(0, r),
    ...se(t),
    ...e.slice(r)
  ];
}
var xt = (e, r, t) => Array.isArray(e) ? (P(e[t]) && (e[t] = void 0), e.splice(t, 0, e.splice(r, 1)[0]), e) : [], gt = (e, r) => [
  ...se(r),
  ...se(e)
];
function wi(e, r) {
  let t = 0;
  const s = [...e];
  for (const n of r)
    s.splice(n - t, 1), t++;
  return Me(s).length ? s : [];
}
var vt = (e, r) => P(r) ? [] : wi(e, se(r).sort((t, s) => t - s)), bt = (e, r, t) => {
  [e[r], e[t]] = [e[t], e[r]];
};
function ji(e, r) {
  const t = r.slice(0, -1).length;
  let s = 0;
  for (; s < t; )
    e = P(e) ? s++ : e[r[s++]];
  return e;
}
function Fi(e) {
  for (const r in e)
    if (e.hasOwnProperty(r) && !P(e[r]))
      return !1;
  return !0;
}
function G(e, r) {
  const t = Array.isArray(r) ? r : Ut(r) ? [r] : Gr(r), s = t.length === 1 ? e : ji(e, t), n = t.length - 1, i = t[n];
  return s && delete s[i], n !== 0 && (q(s) && ee(s) || Array.isArray(s) && Fi(s)) && G(e, t.slice(0, -1)), e;
}
var fr = (e, r, t) => (e[r] = t, e);
function ki(e) {
  const r = ue(), { control: t = r.control, name: s, keyName: n = "id", shouldUnregister: i } = e, [a, l] = F.useState(t._getFieldArray(s)), c = F.useRef(t._getFieldArray(s).map(xe)), m = F.useRef(a), h = F.useRef(s), y = F.useRef(!1);
  h.current = s, m.current = a, t._names.array.add(s), e.rules && t.register(s, e.rules), Hr({
    next: ({ values: _, name: j }) => {
      if (j === h.current || !j) {
        const T = v(_, h.current);
        Array.isArray(T) && (l(T), c.current = T.map(xe));
      }
    },
    subject: t._subjects.array
  });
  const f = F.useCallback((_) => {
    y.current = !0, t._updateFieldArray(s, _);
  }, [t, s]), S = (_, j) => {
    const T = se(J(_)), L = pt(t._getFieldArray(s), T);
    t._names.focus = ht(s, L.length - 1, j), c.current = pt(c.current, T.map(xe)), f(L), l(L), t._updateFieldArray(s, L, pt, {
      argA: mt(_)
    });
  }, w = (_, j) => {
    const T = se(J(_)), L = gt(t._getFieldArray(s), T);
    t._names.focus = ht(s, 0, j), c.current = gt(c.current, T.map(xe)), f(L), l(L), t._updateFieldArray(s, L, gt, {
      argA: mt(_)
    });
  }, $ = (_) => {
    const j = vt(t._getFieldArray(s), _);
    c.current = vt(c.current, _), f(j), l(j), t._updateFieldArray(s, j, vt, {
      argA: _
    });
  }, D = (_, j, T) => {
    const L = se(J(j)), Y = yt(t._getFieldArray(s), _, L);
    t._names.focus = ht(s, _, T), c.current = yt(c.current, _, L.map(xe)), f(Y), l(Y), t._updateFieldArray(s, Y, yt, {
      argA: _,
      argB: mt(j)
    });
  }, I = (_, j) => {
    const T = t._getFieldArray(s);
    bt(T, _, j), bt(c.current, _, j), f(T), l(T), t._updateFieldArray(s, T, bt, {
      argA: _,
      argB: j
    }, !1);
  }, A = (_, j) => {
    const T = t._getFieldArray(s);
    xt(T, _, j), xt(c.current, _, j), f(T), l(T), t._updateFieldArray(s, T, xt, {
      argA: _,
      argB: j
    }, !1);
  }, X = (_, j) => {
    const T = J(j), L = fr(t._getFieldArray(s), _, T);
    c.current = [...L].map((Y, H) => !Y || H === _ ? xe() : c.current[H]), f(L), l([...L]), t._updateFieldArray(s, L, fr, {
      argA: _,
      argB: T
    }, !0, !1);
  }, K = (_) => {
    const j = se(J(_));
    c.current = j.map(xe), f([...j]), l([...j]), t._updateFieldArray(s, [...j], (T) => T, {}, !0, !1);
  };
  return F.useEffect(() => {
    if (t._state.action = !1, Ct(s, t._names) && t._subjects.state.next({
      ...t._formState
    }), y.current && (!Ie(t._options.mode).isOnSubmit || t._formState.isSubmitted))
      if (t._options.resolver)
        t._executeSchema([s]).then((_) => {
          const j = v(_.errors, s), T = v(t._formState.errors, s);
          (T ? !j && T.type || j && (T.type !== j.type || T.message !== j.message) : j && j.type) && (j ? R(t._formState.errors, s, j) : G(t._formState.errors, s), t._subjects.state.next({
            errors: t._formState.errors
          }));
        });
      else {
        const _ = v(t._fields, s);
        _ && _._f && !(Ie(t._options.reValidateMode).isOnSubmit && Ie(t._options.mode).isOnSubmit) && Et(_, t._formValues, t._options.criteriaMode === ie.all, t._options.shouldUseNativeValidation, !0).then((j) => !ee(j) && t._subjects.state.next({
          errors: Zr(t._formState.errors, j, s)
        }));
      }
    t._subjects.values.next({
      name: s,
      values: { ...t._formValues }
    }), t._names.focus && Ve(t._fields, (_, j) => {
      if (t._names.focus && j.startsWith(t._names.focus) && _.focus)
        return _.focus(), 1;
    }), t._names.focus = "", t._updateValid(), y.current = !1;
  }, [a, s, t]), F.useEffect(() => (!v(t._formValues, s) && t._updateFieldArray(s), () => {
    (t._options.shouldUnregister || i) && t.unregister(s);
  }), [s, t, n, i]), {
    swap: F.useCallback(I, [f, s, t]),
    move: F.useCallback(A, [f, s, t]),
    prepend: F.useCallback(w, [f, s, t]),
    append: F.useCallback(S, [f, s, t]),
    remove: F.useCallback($, [f, s, t]),
    insert: F.useCallback(D, [f, s, t]),
    update: F.useCallback(X, [f, s, t]),
    replace: F.useCallback(K, [f, s, t]),
    fields: F.useMemo(() => a.map((_, j) => ({
      ..._,
      [n]: c.current[j] || xe()
    })), [a, n])
  };
}
var _t = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const i of e)
        i.next && i.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((i) => i !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Tt = (e) => te(e) || !qr(e);
function ge(e, r) {
  if (Tt(e) || Tt(r))
    return e === r;
  if (we(e) && we(r))
    return e.getTime() === r.getTime();
  const t = Object.keys(e), s = Object.keys(r);
  if (t.length !== s.length)
    return !1;
  for (const n of t) {
    const i = e[n];
    if (!s.includes(n))
      return !1;
    if (n !== "ref") {
      const a = r[n];
      if (we(i) && we(a) || q(i) && q(a) || Array.isArray(i) && Array.isArray(a) ? !ge(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var Jr = (e) => e.type === "select-multiple", Ai = (e) => qt(e) || Pe(e), St = (e) => Ye(e) && e.isConnected, Qr = (e) => {
  for (const r in e)
    if (me(e[r]))
      return !0;
  return !1;
};
function Qe(e, r = {}) {
  const t = Array.isArray(e);
  if (q(e) || t)
    for (const s in e)
      Array.isArray(e[s]) || q(e[s]) && !Qr(e[s]) ? (r[s] = Array.isArray(e[s]) ? [] : {}, Qe(e[s], r[s])) : te(e[s]) || (r[s] = !0);
  return r;
}
function Kr(e, r, t) {
  const s = Array.isArray(e);
  if (q(e) || s)
    for (const n in e)
      Array.isArray(e[n]) || q(e[n]) && !Qr(e[n]) ? P(r) || Tt(t[n]) ? t[n] = Array.isArray(e[n]) ? Qe(e[n], []) : { ...Qe(e[n]) } : Kr(e[n], te(r) ? {} : r[n], t[n]) : t[n] = !ge(e[n], r[n]);
  return t;
}
var $e = (e, r) => Kr(e, r, Qe(r)), es = (e, { valueAsNumber: r, valueAsDate: t, setValueAs: s }) => P(e) ? e : r ? e === "" ? NaN : e && +e : t && de(e) ? new Date(e) : s ? s(e) : e;
function wt(e) {
  const r = e.ref;
  if (!(e.refs ? e.refs.every((t) => t.disabled) : r.disabled))
    return Bt(r) ? r.files : qt(r) ? Yr(e.refs).value : Jr(r) ? [...r.selectedOptions].map(({ value: t }) => t) : Pe(r) ? Xr(e.refs).value : es(P(r.value) ? e.ref.value : r.value, e);
}
var Ci = (e, r, t, s) => {
  const n = {};
  for (const i of e) {
    const a = v(r, i);
    a && R(n, i, a._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: n,
    shouldUseNativeValidation: s
  };
}, Re = (e) => P(e) ? e : Je(e) ? e.source : q(e) ? Je(e.value) ? e.value.source : e.value : e;
const hr = "AsyncFunction";
var Ei = (e) => (!e || !e.validate) && !!(me(e.validate) && e.validate.constructor.name === hr || q(e.validate) && Object.values(e.validate).find((r) => r.constructor.name === hr)), Ti = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function pr(e, r, t) {
  const s = v(e, t);
  if (s || Ut(t))
    return {
      error: s,
      name: t
    };
  const n = t.split(".");
  for (; n.length; ) {
    const i = n.join("."), a = v(r, i), l = v(e, i);
    if (a && !Array.isArray(a) && t !== i)
      return { name: t };
    if (l && l.type)
      return {
        name: i,
        error: l
      };
    n.pop();
  }
  return {
    name: t
  };
}
var Vi = (e, r, t, s, n) => n.isOnAll ? !1 : !t && n.isOnTouch ? !(r || e) : (t ? s.isOnBlur : n.isOnBlur) ? !e : (t ? s.isOnChange : n.isOnChange) ? e : !0, Oi = (e, r) => !Me(v(e, r)).length && G(e, r);
const Di = {
  mode: ie.onSubmit,
  reValidateMode: ie.onChange,
  shouldFocusError: !0
};
function Ni(e = {}) {
  let r = {
    ...Di,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: me(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: r.errors || {},
    disabled: r.disabled || !1
  }, s = {}, n = q(r.defaultValues) || q(r.values) ? J(r.defaultValues || r.values) || {} : {}, i = r.shouldUnregister ? {} : J(n), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const h = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, y = {
    values: _t(),
    array: _t(),
    state: _t()
  }, f = Ie(r.mode), S = Ie(r.reValidateMode), w = r.criteriaMode === ie.all, $ = (u) => (d) => {
    clearTimeout(m), m = setTimeout(u, d);
  }, D = async (u) => {
    if (!e.disabled && (h.isValid || u)) {
      const d = r.resolver ? ee((await L()).errors) : await H(s, !0);
      d !== t.isValid && y.state.next({
        isValid: d
      });
    }
  }, I = (u, d) => {
    !e.disabled && (h.isValidating || h.validatingFields) && ((u || Array.from(l.mount)).forEach((p) => {
      p && (d ? R(t.validatingFields, p, d) : G(t.validatingFields, p));
    }), y.state.next({
      validatingFields: t.validatingFields,
      isValidating: !ee(t.validatingFields)
    }));
  }, A = (u, d = [], p, b, g = !0, x = !0) => {
    if (b && p && !e.disabled) {
      if (a.action = !0, x && Array.isArray(v(s, u))) {
        const k = p(v(s, u), b.argA, b.argB);
        g && R(s, u, k);
      }
      if (x && Array.isArray(v(t.errors, u))) {
        const k = p(v(t.errors, u), b.argA, b.argB);
        g && R(t.errors, u, k), Oi(t.errors, u);
      }
      if (h.touchedFields && x && Array.isArray(v(t.touchedFields, u))) {
        const k = p(v(t.touchedFields, u), b.argA, b.argB);
        g && R(t.touchedFields, u, k);
      }
      h.dirtyFields && (t.dirtyFields = $e(n, i)), y.state.next({
        name: u,
        isDirty: C(u, d),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      R(i, u, d);
  }, X = (u, d) => {
    R(t.errors, u, d), y.state.next({
      errors: t.errors
    });
  }, K = (u) => {
    t.errors = u, y.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, _ = (u, d, p, b) => {
    const g = v(s, u);
    if (g) {
      const x = v(i, u, P(p) ? v(n, u) : p);
      P(x) || b && b.defaultChecked || d ? R(i, u, d ? x : wt(g._f)) : Q(u, x), a.mount && D();
    }
  }, j = (u, d, p, b, g) => {
    let x = !1, k = !1;
    const O = {
      name: u
    };
    if (!e.disabled) {
      const z = !!(v(s, u) && v(s, u)._f && v(s, u)._f.disabled);
      if (!p || b) {
        h.isDirty && (k = t.isDirty, t.isDirty = O.isDirty = C(), x = k !== O.isDirty);
        const Z = z || ge(v(n, u), d);
        k = !!(!z && v(t.dirtyFields, u)), Z || z ? G(t.dirtyFields, u) : R(t.dirtyFields, u, !0), O.dirtyFields = t.dirtyFields, x = x || h.dirtyFields && k !== !Z;
      }
      if (p) {
        const Z = v(t.touchedFields, u);
        Z || (R(t.touchedFields, u, p), O.touchedFields = t.touchedFields, x = x || h.touchedFields && Z !== p);
      }
      x && g && y.state.next(O);
    }
    return x ? O : {};
  }, T = (u, d, p, b) => {
    const g = v(t.errors, u), x = h.isValid && ce(d) && t.isValid !== d;
    if (e.delayError && p ? (c = $(() => X(u, p)), c(e.delayError)) : (clearTimeout(m), c = null, p ? R(t.errors, u, p) : G(t.errors, u)), (p ? !ge(g, p) : g) || !ee(b) || x) {
      const k = {
        ...b,
        ...x && ce(d) ? { isValid: d } : {},
        errors: t.errors,
        name: u
      };
      t = {
        ...t,
        ...k
      }, y.state.next(k);
    }
  }, L = async (u) => {
    I(u, !0);
    const d = await r.resolver(i, r.context, Ci(u || l.mount, s, r.criteriaMode, r.shouldUseNativeValidation));
    return I(u), d;
  }, Y = async (u) => {
    const { errors: d } = await L(u);
    if (u)
      for (const p of u) {
        const b = v(d, p);
        b ? R(t.errors, p, b) : G(t.errors, p);
      }
    else
      t.errors = d;
    return d;
  }, H = async (u, d, p = {
    valid: !0
  }) => {
    for (const b in u) {
      const g = u[b];
      if (g) {
        const { _f: x, ...k } = g;
        if (x) {
          const O = l.array.has(x.name), z = g._f && Ei(g._f);
          z && h.validatingFields && I([b], !0);
          const Z = await Et(g, i, w, r.shouldUseNativeValidation && !d, O);
          if (z && h.validatingFields && I([b]), Z[x.name] && (p.valid = !1, d))
            break;
          !d && (v(Z, x.name) ? O ? Zr(t.errors, Z, x.name) : R(t.errors, x.name, Z[x.name]) : G(t.errors, x.name));
        }
        !ee(k) && await H(k, d, p);
      }
    }
    return p.valid;
  }, M = () => {
    for (const u of l.unMount) {
      const d = v(s, u);
      d && (d._f.refs ? d._f.refs.every((p) => !St(p)) : !St(d._f.ref)) && ot(u);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, C = (u, d) => !e.disabled && (u && d && R(i, u, d), !ge(Xt(), n)), N = (u, d, p) => Si(u, l, {
    ...a.mount ? i : P(d) ? n : de(u) ? { [u]: d } : d
  }, p, d), B = (u) => Me(v(a.mount ? i : n, u, e.shouldUnregister ? v(n, u, []) : [])), Q = (u, d, p = {}) => {
    const b = v(s, u);
    let g = d;
    if (b) {
      const x = b._f;
      x && (!x.disabled && R(i, u, es(d, x)), g = Ye(x.ref) && te(d) ? "" : d, Jr(x.ref) ? [...x.ref.options].forEach((k) => k.selected = g.includes(k.value)) : x.refs ? Pe(x.ref) ? x.refs.length > 1 ? x.refs.forEach((k) => (!k.defaultChecked || !k.disabled) && (k.checked = Array.isArray(g) ? !!g.find((O) => O === k.value) : g === k.value)) : x.refs[0] && (x.refs[0].checked = !!g) : x.refs.forEach((k) => k.checked = k.value === g) : Bt(x.ref) ? x.ref.value = "" : (x.ref.value = g, x.ref.type || y.values.next({
        name: u,
        values: { ...i }
      })));
    }
    (p.shouldDirty || p.shouldTouch) && j(u, g, p.shouldTouch, p.shouldDirty, !0), p.shouldValidate && Ne(u);
  }, le = (u, d, p) => {
    for (const b in d) {
      const g = d[b], x = `${u}.${b}`, k = v(s, x);
      (l.array.has(u) || q(g) || k && !k._f) && !we(g) ? le(x, g, p) : Q(x, g, p);
    }
  }, ne = (u, d, p = {}) => {
    const b = v(s, u), g = l.array.has(u), x = J(d);
    R(i, u, x), g ? (y.array.next({
      name: u,
      values: { ...i }
    }), (h.isDirty || h.dirtyFields) && p.shouldDirty && y.state.next({
      name: u,
      dirtyFields: $e(n, i),
      isDirty: C(u, x)
    })) : b && !b._f && !te(x) ? le(u, x, p) : Q(u, x, p), Ct(u, l) && y.state.next({ ...t }), y.values.next({
      name: a.mount ? u : void 0,
      values: { ...i }
    });
  }, Oe = async (u) => {
    a.mount = !0;
    const d = u.target;
    let p = d.name, b = !0;
    const g = v(s, p), x = () => d.type ? wt(g._f) : mi(u), k = (O) => {
      b = Number.isNaN(O) || we(O) && isNaN(O.getTime()) || ge(O, v(i, p, O));
    };
    if (g) {
      let O, z;
      const Z = x(), Se = u.type === lr.BLUR || u.type === lr.FOCUS_OUT, xs = !Ti(g._f) && !r.resolver && !v(t.errors, p) && !g._f.deps || Vi(Se, v(t.touchedFields, p), t.isSubmitted, S, f), ct = Ct(p, l, Se);
      R(i, p, Z), Se ? (g._f.onBlur && g._f.onBlur(u), c && c(0)) : g._f.onChange && g._f.onChange(u);
      const dt = j(p, Z, Se, !1), gs = !ee(dt) || ct;
      if (!Se && y.values.next({
        name: p,
        type: u.type,
        values: { ...i }
      }), xs)
        return h.isValid && (e.mode === "onBlur" ? Se && D() : D()), gs && y.state.next({ name: p, ...ct ? {} : dt });
      if (!Se && ct && y.state.next({ ...t }), r.resolver) {
        const { errors: sr } = await L([p]);
        if (k(Z), b) {
          const vs = pr(t.errors, s, p), nr = pr(sr, s, vs.name || p);
          O = nr.error, p = nr.name, z = ee(sr);
        }
      } else
        I([p], !0), O = (await Et(g, i, w, r.shouldUseNativeValidation))[p], I([p]), k(Z), b && (O ? z = !1 : h.isValid && (z = await H(s, !0)));
      b && (g._f.deps && Ne(g._f.deps), T(p, z, O, dt));
    }
  }, De = (u, d) => {
    if (v(t.errors, d) && u.focus)
      return u.focus(), 1;
  }, Ne = async (u, d = {}) => {
    let p, b;
    const g = se(u);
    if (r.resolver) {
      const x = await Y(P(u) ? u : g);
      p = ee(x), b = u ? !g.some((k) => v(x, k)) : p;
    } else u ? (b = (await Promise.all(g.map(async (x) => {
      const k = v(s, x);
      return await H(k && k._f ? { [x]: k } : k);
    }))).every(Boolean), !(!b && !t.isValid) && D()) : b = p = await H(s);
    return y.state.next({
      ...!de(u) || h.isValid && p !== t.isValid ? {} : { name: u },
      ...r.resolver || !u ? { isValid: p } : {},
      errors: t.errors
    }), d.shouldFocus && !b && Ve(s, De, u ? g : l.mount), b;
  }, Xt = (u) => {
    const d = {
      ...a.mount ? i : n
    };
    return P(u) ? d : de(u) ? v(d, u) : u.map((p) => v(d, p));
  }, Yt = (u, d) => ({
    invalid: !!v((d || t).errors, u),
    isDirty: !!v((d || t).dirtyFields, u),
    error: v((d || t).errors, u),
    isValidating: !!v(t.validatingFields, u),
    isTouched: !!v((d || t).touchedFields, u)
  }), hs = (u) => {
    u && se(u).forEach((d) => G(t.errors, d)), y.state.next({
      errors: u ? t.errors : {}
    });
  }, Jt = (u, d, p) => {
    const b = (v(s, u, { _f: {} })._f || {}).ref, g = v(t.errors, u) || {}, { ref: x, message: k, type: O, ...z } = g;
    R(t.errors, u, {
      ...z,
      ...d,
      ref: b
    }), y.state.next({
      name: u,
      errors: t.errors,
      isValid: !1
    }), p && p.shouldFocus && b && b.focus && b.focus();
  }, ps = (u, d) => me(u) ? y.values.subscribe({
    next: (p) => u(N(void 0, d), p)
  }) : N(u, d, !0), ot = (u, d = {}) => {
    for (const p of u ? se(u) : l.mount)
      l.mount.delete(p), l.array.delete(p), d.keepValue || (G(s, p), G(i, p)), !d.keepError && G(t.errors, p), !d.keepDirty && G(t.dirtyFields, p), !d.keepTouched && G(t.touchedFields, p), !d.keepIsValidating && G(t.validatingFields, p), !r.shouldUnregister && !d.keepDefaultValue && G(n, p);
    y.values.next({
      values: { ...i }
    }), y.state.next({
      ...t,
      ...d.keepDirty ? { isDirty: C() } : {}
    }), !d.keepIsValid && D();
  }, Qt = ({ disabled: u, name: d, field: p, fields: b, value: g }) => {
    if (ce(u) && a.mount || u) {
      const x = u ? void 0 : P(g) ? wt(p ? p._f : v(b, d)._f) : g;
      R(i, d, x), j(d, x, !1, !1, !0);
    }
  }, ut = (u, d = {}) => {
    let p = v(s, u);
    const b = ce(d.disabled) || ce(e.disabled);
    return R(s, u, {
      ...p || {},
      _f: {
        ...p && p._f ? p._f : { ref: { name: u } },
        name: u,
        mount: !0,
        ...d
      }
    }), l.mount.add(u), p ? Qt({
      field: p,
      disabled: ce(d.disabled) ? d.disabled : e.disabled,
      name: u,
      value: d.value
    }) : _(u, !0, d.value), {
      ...b ? { disabled: d.disabled || e.disabled } : {},
      ...r.progressive ? {
        required: !!d.required,
        min: Re(d.min),
        max: Re(d.max),
        minLength: Re(d.minLength),
        maxLength: Re(d.maxLength),
        pattern: Re(d.pattern)
      } : {},
      name: u,
      onChange: Oe,
      onBlur: Oe,
      ref: (g) => {
        if (g) {
          ut(u, d), p = v(s, u);
          const x = P(g.value) && g.querySelectorAll && g.querySelectorAll("input,select,textarea")[0] || g, k = Ai(x), O = p._f.refs || [];
          if (k ? O.find((z) => z === x) : x === p._f.ref)
            return;
          R(s, u, {
            _f: {
              ...p._f,
              ...k ? {
                refs: [
                  ...O.filter(St),
                  x,
                  ...Array.isArray(v(n, u)) ? [{}] : []
                ],
                ref: { type: x.type, name: u }
              } : { ref: x }
            }
          }), _(u, !1, void 0, x);
        } else
          p = v(s, u, {}), p._f && (p._f.mount = !1), (r.shouldUnregister || d.shouldUnregister) && !(xi(l.array, u) && a.action) && l.unMount.add(u);
      }
    };
  }, Kt = () => r.shouldFocusError && Ve(s, De, l.mount), ms = (u) => {
    ce(u) && (y.state.next({ disabled: u }), Ve(s, (d, p) => {
      const b = v(s, p);
      b && (d.disabled = b._f.disabled || u, Array.isArray(b._f.refs) && b._f.refs.forEach((g) => {
        g.disabled = b._f.disabled || u;
      }));
    }, 0, !1));
  }, er = (u, d) => async (p) => {
    let b;
    p && (p.preventDefault && p.preventDefault(), p.persist && p.persist());
    let g = J(i);
    if (y.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: x, values: k } = await L();
      t.errors = x, g = k;
    } else
      await H(s);
    if (G(t.errors, "root"), ee(t.errors)) {
      y.state.next({
        errors: {}
      });
      try {
        await u(g, p);
      } catch (x) {
        b = x;
      }
    } else
      d && await d({ ...t.errors }, p), Kt(), setTimeout(Kt);
    if (y.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ee(t.errors) && !b,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), b)
      throw b;
  }, ys = (u, d = {}) => {
    v(s, u) && (P(d.defaultValue) ? ne(u, J(v(n, u))) : (ne(u, d.defaultValue), R(n, u, J(d.defaultValue))), d.keepTouched || G(t.touchedFields, u), d.keepDirty || (G(t.dirtyFields, u), t.isDirty = d.defaultValue ? C(u, J(v(n, u))) : C()), d.keepError || (G(t.errors, u), h.isValid && D()), y.state.next({ ...t }));
  }, tr = (u, d = {}) => {
    const p = u ? J(u) : n, b = J(p), g = ee(u), x = g ? n : b;
    if (d.keepDefaultValues || (n = p), !d.keepValues) {
      if (d.keepDirtyValues) {
        const k = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($e(n, i))
        ]);
        for (const O of Array.from(k))
          v(t.dirtyFields, O) ? R(x, O, v(i, O)) : ne(O, v(x, O));
      } else {
        if (Mt && P(u))
          for (const k of l.mount) {
            const O = v(s, k);
            if (O && O._f) {
              const z = Array.isArray(O._f.refs) ? O._f.refs[0] : O._f.ref;
              if (Ye(z)) {
                const Z = z.closest("form");
                if (Z) {
                  Z.reset();
                  break;
                }
              }
            }
          }
        s = {};
      }
      i = e.shouldUnregister ? d.keepDefaultValues ? J(n) : {} : J(x), y.array.next({
        values: { ...x }
      }), y.values.next({
        values: { ...x }
      });
    }
    l = {
      mount: d.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !h.isValid || !!d.keepIsValid || !!d.keepDirtyValues, a.watch = !!e.shouldUnregister, y.state.next({
      submitCount: d.keepSubmitCount ? t.submitCount : 0,
      isDirty: g ? !1 : d.keepDirty ? t.isDirty : !!(d.keepDefaultValues && !ge(u, n)),
      isSubmitted: d.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: g ? {} : d.keepDirtyValues ? d.keepDefaultValues && i ? $e(n, i) : t.dirtyFields : d.keepDefaultValues && u ? $e(n, u) : d.keepDirty ? t.dirtyFields : {},
      touchedFields: d.keepTouched ? t.touchedFields : {},
      errors: d.keepErrors ? t.errors : {},
      isSubmitSuccessful: d.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, rr = (u, d) => tr(me(u) ? u(i) : u, d);
  return {
    control: {
      register: ut,
      unregister: ot,
      getFieldState: Yt,
      handleSubmit: er,
      setError: Jt,
      _executeSchema: L,
      _getWatch: N,
      _getDirty: C,
      _updateValid: D,
      _removeUnmounted: M,
      _updateFieldArray: A,
      _updateDisabledField: Qt,
      _getFieldArray: B,
      _reset: tr,
      _resetDefaultValues: () => me(r.defaultValues) && r.defaultValues().then((u) => {
        rr(u, r.resetOptions), y.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (u) => {
        t = {
          ...t,
          ...u
        };
      },
      _disableForm: ms,
      _subjects: y,
      _proxyFormState: h,
      _setErrors: K,
      get _fields() {
        return s;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return a;
      },
      set _state(u) {
        a = u;
      },
      get _defaultValues() {
        return n;
      },
      get _names() {
        return l;
      },
      set _names(u) {
        l = u;
      },
      get _formState() {
        return t;
      },
      set _formState(u) {
        t = u;
      },
      get _options() {
        return r;
      },
      set _options(u) {
        r = {
          ...r,
          ...u
        };
      }
    },
    trigger: Ne,
    register: ut,
    handleSubmit: er,
    watch: ps,
    setValue: ne,
    getValues: Xt,
    reset: rr,
    resetField: ys,
    clearErrors: hs,
    unregister: ot,
    setError: Jt,
    setFocus: (u, d = {}) => {
      const p = v(s, u), b = p && p._f;
      if (b) {
        const g = b.refs ? b.refs[0] : b.ref;
        g.focus && (g.focus(), d.shouldSelect && g.select());
      }
    },
    getFieldState: Yt
  };
}
function $i(e = {}) {
  const r = F.useRef(), t = F.useRef(), [s, n] = F.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: me(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: me(e.defaultValues) ? void 0 : e.defaultValues
  });
  r.current || (r.current = {
    ...Ni(e),
    formState: s
  });
  const i = r.current.control;
  return i._options = e, Hr({
    subject: i._subjects.state,
    next: (a) => {
      _i(a, i._proxyFormState, i._updateFormState) && n({ ...i._formState });
    }
  }), F.useEffect(() => i._disableForm(e.disabled), [i, e.disabled]), F.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const a = i._getDirty();
      a !== s.isDirty && i._subjects.state.next({
        isDirty: a
      });
    }
  }, [i, s.isDirty]), F.useEffect(() => {
    e.values && !ge(e.values, t.current) ? (i._reset(e.values, i._options.resetOptions), t.current = e.values, n((a) => ({ ...a }))) : i._resetDefaultValues();
  }, [e.values, i]), F.useEffect(() => {
    e.errors && i._setErrors(e.errors);
  }, [e.errors, i]), F.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), F.useEffect(() => {
    e.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [e.shouldUnregister, i]), F.useEffect(() => {
    r.current && (r.current.watch = r.current.watch.bind({}));
  }, [s]), r.current.formState = bi(s, i), r.current;
}
const mr = (e, r, t) => {
  if (e && "reportValidity" in e) {
    const s = v(t, r);
    e.setCustomValidity(s && s.message || ""), e.reportValidity();
  }
}, ts = (e, r) => {
  for (const t in r.fields) {
    const s = r.fields[t];
    s && s.ref && "reportValidity" in s.ref ? mr(s.ref, t, e) : s.refs && s.refs.forEach((n) => mr(n, t, e));
  }
}, Ri = (e, r) => {
  r.shouldUseNativeValidation && ts(e, r);
  const t = {};
  for (const s in e) {
    const n = v(r.fields, s), i = Object.assign(e[s] || {}, { ref: n && n.ref });
    if (Ii(r.names || Object.keys(e), s)) {
      const a = Object.assign({}, v(t, s));
      R(a, "root", i), R(t, s, a);
    } else R(t, s, i);
  }
  return t;
}, Ii = (e, r) => e.some((t) => t.startsWith(r + "."));
function Li(e, r, t) {
  return r === void 0 && (r = {}), t === void 0 && (t = {}), function(s, n, i) {
    try {
      return Promise.resolve(function(a, l) {
        try {
          var c = (r.context, Promise.resolve(e[t.mode === "sync" ? "validateSync" : "validate"](s, Object.assign({ abortEarly: !1 }, r, { context: n }))).then(function(m) {
            return i.shouldUseNativeValidation && ts({}, i), { values: t.raw ? s : m, errors: {} };
          }));
        } catch (m) {
          return l(m);
        }
        return c && c.then ? c.then(void 0, l) : c;
      }(0, function(a) {
        if (!a.inner) throw a;
        return { values: {}, errors: Ri((l = a, c = !i.shouldUseNativeValidation && i.criteriaMode === "all", (l.inner || []).reduce(function(m, h) {
          if (m[h.path] || (m[h.path] = { message: h.message, type: h.type }), c) {
            var y = m[h.path].types, f = y && y[h.type];
            m[h.path] = zr(h.path, c, m, h.type, f ? [].concat(f, h.message) : h.message);
          }
          return m;
        }, {})), i) };
        var l, c;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
}
function Fe(e) {
  this._maxSize = e, this.clear();
}
Fe.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Fe.prototype.get = function(e) {
  return this._values[e];
};
Fe.prototype.set = function(e, r) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = r;
};
var Pi = /[^.^\]^[]+|(?=\[\]|\.\.)/g, rs = /^\d+$/, Mi = /^\d/, Ui = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Bi = /^\s*(['"]?)(.*?)(\1)\s*$/, Gt = 512, yr = new Fe(Gt), xr = new Fe(Gt), gr = new Fe(Gt), je = {
  Cache: Fe,
  split: Vt,
  normalizePath: jt,
  setter: function(e) {
    var r = jt(e);
    return xr.get(e) || xr.set(e, function(s, n) {
      for (var i = 0, a = r.length, l = s; i < a - 1; ) {
        var c = r[i];
        if (c === "__proto__" || c === "constructor" || c === "prototype")
          return s;
        l = l[r[i++]];
      }
      l[r[i]] = n;
    });
  },
  getter: function(e, r) {
    var t = jt(e);
    return gr.get(e) || gr.set(e, function(n) {
      for (var i = 0, a = t.length; i < a; )
        if (n != null || !r) n = n[t[i++]];
        else return;
      return n;
    });
  },
  join: function(e) {
    return e.reduce(function(r, t) {
      return r + (Wt(t) || rs.test(t) ? "[" + t + "]" : (r ? "." : "") + t);
    }, "");
  },
  forEach: function(e, r, t) {
    qi(Array.isArray(e) ? e : Vt(e), r, t);
  }
};
function jt(e) {
  return yr.get(e) || yr.set(
    e,
    Vt(e).map(function(r) {
      return r.replace(Bi, "$2");
    })
  );
}
function Vt(e) {
  return e.match(Pi) || [""];
}
function qi(e, r, t) {
  var s = e.length, n, i, a, l;
  for (i = 0; i < s; i++)
    n = e[i], n && (Hi(n) && (n = '"' + n + '"'), l = Wt(n), a = !l && /^\d+$/.test(n), r.call(t, n, l, a, i, e));
}
function Wt(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function Gi(e) {
  return e.match(Mi) && !e.match(rs);
}
function Wi(e) {
  return Ui.test(e);
}
function Hi(e) {
  return !Wt(e) && (Gi(e) || Wi(e));
}
const zi = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, it = (e) => e.match(zi) || [], at = (e) => e[0].toUpperCase() + e.slice(1), Ht = (e, r) => it(e).join(r).toLowerCase(), ss = (e) => it(e).reduce(
  (r, t) => `${r}${r ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`,
  ""
), Zi = (e) => at(ss(e)), Xi = (e) => Ht(e, "_"), Yi = (e) => Ht(e, "-"), Ji = (e) => at(Ht(e, " ")), Qi = (e) => it(e).map(at).join(" ");
var Ft = {
  words: it,
  upperFirst: at,
  camelCase: ss,
  pascalCase: Zi,
  snakeCase: Xi,
  kebabCase: Yi,
  sentenceCase: Ji,
  titleCase: Qi
}, zt = { exports: {} };
zt.exports = function(e) {
  return ns(Ki(e), e);
};
zt.exports.array = ns;
function ns(e, r) {
  var t = e.length, s = new Array(t), n = {}, i = t, a = ea(r), l = ta(e);
  for (r.forEach(function(m) {
    if (!l.has(m[0]) || !l.has(m[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    n[i] || c(e[i], i, /* @__PURE__ */ new Set());
  return s;
  function c(m, h, y) {
    if (y.has(m)) {
      var f;
      try {
        f = ", node was:" + JSON.stringify(m);
      } catch {
        f = "";
      }
      throw new Error("Cyclic dependency" + f);
    }
    if (!l.has(m))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(m));
    if (!n[h]) {
      n[h] = !0;
      var S = a.get(m) || /* @__PURE__ */ new Set();
      if (S = Array.from(S), h = S.length) {
        y.add(m);
        do {
          var w = S[--h];
          c(w, l.get(w), y);
        } while (h);
        y.delete(m);
      }
      s[--t] = m;
    }
  }
}
function Ki(e) {
  for (var r = /* @__PURE__ */ new Set(), t = 0, s = e.length; t < s; t++) {
    var n = e[t];
    r.add(n[0]), r.add(n[1]);
  }
  return Array.from(r);
}
function ea(e) {
  for (var r = /* @__PURE__ */ new Map(), t = 0, s = e.length; t < s; t++) {
    var n = e[t];
    r.has(n[0]) || r.set(n[0], /* @__PURE__ */ new Set()), r.has(n[1]) || r.set(n[1], /* @__PURE__ */ new Set()), r.get(n[0]).add(n[1]);
  }
  return r;
}
function ta(e) {
  for (var r = /* @__PURE__ */ new Map(), t = 0, s = e.length; t < s; t++)
    r.set(e[t], t);
  return r;
}
var ra = zt.exports;
const sa = /* @__PURE__ */ cn(ra), na = Object.prototype.toString, ia = Error.prototype.toString, aa = RegExp.prototype.toString, la = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", oa = /^Symbol\((.*)\)(.*)$/;
function ua(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function vr(e, r = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const t = typeof e;
  if (t === "number") return ua(e);
  if (t === "string") return r ? `"${e}"` : e;
  if (t === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (t === "symbol") return la.call(e).replace(oa, "Symbol($1)");
  const s = na.call(e).slice(8, -1);
  return s === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : s === "Error" || e instanceof Error ? "[" + ia.call(e) + "]" : s === "RegExp" ? aa.call(e) : null;
}
function be(e, r) {
  let t = vr(e, r);
  return t !== null ? t : JSON.stringify(e, function(s, n) {
    let i = vr(this[s], r);
    return i !== null ? i : n;
  }, 2);
}
function is(e) {
  return e == null ? [] : [].concat(e);
}
let as, ls, os, ca = /\$\{\s*(\w+)\s*\}/g;
as = Symbol.toStringTag;
class br {
  constructor(r, t, s, n) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[as] = "Error", this.name = "ValidationError", this.value = t, this.path = s, this.type = n, this.errors = [], this.inner = [], is(r).forEach((i) => {
      if (re.isError(i)) {
        this.errors.push(...i.errors);
        const a = i.inner.length ? i.inner : [i];
        this.inner.push(...a);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
ls = Symbol.hasInstance;
os = Symbol.toStringTag;
class re extends Error {
  static formatError(r, t) {
    const s = t.label || t.path || "this";
    return s !== t.path && (t = Object.assign({}, t, {
      path: s
    })), typeof r == "string" ? r.replace(ca, (n, i) => be(t[i])) : typeof r == "function" ? r(t) : r;
  }
  static isError(r) {
    return r && r.name === "ValidationError";
  }
  constructor(r, t, s, n, i) {
    const a = new br(r, t, s, n);
    if (i)
      return a;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[os] = "Error", this.name = a.name, this.message = a.message, this.type = a.type, this.value = a.value, this.path = a.path, this.errors = a.errors, this.inner = a.inner, Error.captureStackTrace && Error.captureStackTrace(this, re);
  }
  static [ls](r) {
    return br[Symbol.hasInstance](r) || super[Symbol.hasInstance](r);
  }
}
let pe = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: r,
    value: t,
    originalValue: s
  }) => {
    const n = s != null && s !== t ? ` (cast from the value \`${be(s, !0)}\`).` : ".";
    return r !== "mixed" ? `${e} must be a \`${r}\` type, but the final value was: \`${be(t, !0)}\`` + n : `${e} must match the configured type. The validated value was: \`${be(t, !0)}\`` + n;
  }
}, da = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, fa = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Ot = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ha = {
  isValue: "${path} field must be ${value}"
}, Dt = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, pa = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, ma = {
  notType: (e) => {
    const {
      path: r,
      value: t,
      spec: s
    } = e, n = s.types.length;
    if (Array.isArray(t)) {
      if (t.length < n) return `${r} tuple value has too few items, expected a length of ${n} but got ${t.length} for value: \`${be(t, !0)}\``;
      if (t.length > n) return `${r} tuple value has too many items, expected a length of ${n} but got ${t.length} for value: \`${be(t, !0)}\``;
    }
    return re.formatError(pe.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: pe,
  string: da,
  number: fa,
  date: Ot,
  object: Dt,
  array: pa,
  boolean: ha,
  tuple: ma
});
const Zt = (e) => e && e.__isYupSchema__;
class Ke {
  static fromOptions(r, t) {
    if (!t.then && !t.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: s,
      then: n,
      otherwise: i
    } = t, a = typeof s == "function" ? s : (...l) => l.every((c) => c === s);
    return new Ke(r, (l, c) => {
      var m;
      let h = a(...l) ? n : i;
      return (m = h?.(c)) != null ? m : c;
    });
  }
  constructor(r, t) {
    this.fn = void 0, this.refs = r, this.refs = r, this.fn = t;
  }
  resolve(r, t) {
    let s = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(t?.value, t?.parent, t?.context)
    )), n = this.fn(s, r, t);
    if (n === void 0 || // @ts-ignore this can be base
    n === r)
      return r;
    if (!Zt(n)) throw new TypeError("conditions must return a schema object");
    return n.resolve(t);
  }
}
const Be = {
  context: "$",
  value: "."
};
class ke {
  constructor(r, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof r != "string") throw new TypeError("ref must be a string, got: " + r);
    if (this.key = r.trim(), r === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Be.context, this.isValue = this.key[0] === Be.value, this.isSibling = !this.isContext && !this.isValue;
    let s = this.isContext ? Be.context : this.isValue ? Be.value : "";
    this.path = this.key.slice(s.length), this.getter = this.path && je.getter(this.path, !0), this.map = t.map;
  }
  getValue(r, t, s) {
    let n = this.isContext ? s : this.isValue ? r : t;
    return this.getter && (n = this.getter(n || {})), this.map && (n = this.map(n)), n;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(r, t) {
    return this.getValue(r, t?.parent, t?.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(r) {
    return r && r.__isYupRef;
  }
}
ke.prototype.__isYupRef = !0;
const us = (e) => e == null;
function Ee(e) {
  function r({
    value: t,
    path: s = "",
    options: n,
    originalValue: i,
    schema: a
  }, l, c) {
    const {
      name: m,
      test: h,
      params: y,
      message: f,
      skipAbsent: S
    } = e;
    let {
      parent: w,
      context: $,
      abortEarly: D = a.spec.abortEarly,
      disableStackTrace: I = a.spec.disableStackTrace
    } = n;
    function A(M) {
      return ke.isRef(M) ? M.getValue(t, w, $) : M;
    }
    function X(M = {}) {
      const C = Object.assign({
        value: t,
        originalValue: i,
        label: a.spec.label,
        path: M.path || s,
        spec: a.spec,
        disableStackTrace: M.disableStackTrace || I
      }, y, M.params);
      for (const B of Object.keys(C)) C[B] = A(C[B]);
      const N = new re(re.formatError(M.message || f, C), t, C.path, M.type || m, C.disableStackTrace);
      return N.params = C, N;
    }
    const K = D ? l : c;
    let _ = {
      path: s,
      parent: w,
      type: m,
      from: n.from,
      createError: X,
      resolve: A,
      options: n,
      originalValue: i,
      schema: a
    };
    const j = (M) => {
      re.isError(M) ? K(M) : M ? c(null) : K(X());
    }, T = (M) => {
      re.isError(M) ? K(M) : l(M);
    };
    if (S && us(t))
      return j(!0);
    let Y;
    try {
      var H;
      if (Y = h.call(_, t, _), typeof ((H = Y) == null ? void 0 : H.then) == "function") {
        if (n.sync)
          throw new Error(`Validation test of type: "${_.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(Y).then(j, T);
      }
    } catch (M) {
      T(M);
      return;
    }
    j(Y);
  }
  return r.OPTIONS = e, r;
}
function ya(e, r, t, s = t) {
  let n, i, a;
  return r ? (je.forEach(r, (l, c, m) => {
    let h = c ? l.slice(1, l.length - 1) : l;
    e = e.resolve({
      context: s,
      parent: n,
      value: t
    });
    let y = e.type === "tuple", f = m ? parseInt(h, 10) : 0;
    if (e.innerType || y) {
      if (y && !m) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${a}" must contain an index to the tuple element, e.g. "${a}[0]"`);
      if (t && f >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${l}, in the path: ${r}. because there is no value at that index. `);
      n = t, t = t && t[f], e = y ? e.spec.types[f] : e.innerType;
    }
    if (!m) {
      if (!e.fields || !e.fields[h]) throw new Error(`The schema does not contain the path: ${r}. (failed at: ${a} which is a type: "${e.type}")`);
      n = t, t = t && t[h], e = e.fields[h];
    }
    i = h, a = c ? "[" + l + "]" : "." + l;
  }), {
    schema: e,
    parent: n,
    parentPath: i
  }) : {
    parent: n,
    parentPath: r,
    schema: e
  };
}
class et extends Set {
  describe() {
    const r = [];
    for (const t of this.values())
      r.push(ke.isRef(t) ? t.describe() : t);
    return r;
  }
  resolveAll(r) {
    let t = [];
    for (const s of this.values())
      t.push(r(s));
    return t;
  }
  clone() {
    return new et(this.values());
  }
  merge(r, t) {
    const s = this.clone();
    return r.forEach((n) => s.add(n)), t.forEach((n) => s.delete(n)), s;
  }
}
function Te(e, r = /* @__PURE__ */ new Map()) {
  if (Zt(e) || !e || typeof e != "object") return e;
  if (r.has(e)) return r.get(e);
  let t;
  if (e instanceof Date)
    t = new Date(e.getTime()), r.set(e, t);
  else if (e instanceof RegExp)
    t = new RegExp(e), r.set(e, t);
  else if (Array.isArray(e)) {
    t = new Array(e.length), r.set(e, t);
    for (let s = 0; s < e.length; s++) t[s] = Te(e[s], r);
  } else if (e instanceof Map) {
    t = /* @__PURE__ */ new Map(), r.set(e, t);
    for (const [s, n] of e.entries()) t.set(s, Te(n, r));
  } else if (e instanceof Set) {
    t = /* @__PURE__ */ new Set(), r.set(e, t);
    for (const s of e) t.add(Te(s, r));
  } else if (e instanceof Object) {
    t = {}, r.set(e, t);
    for (const [s, n] of Object.entries(e)) t[s] = Te(n, r);
  } else
    throw Error(`Unable to clone ${e}`);
  return t;
}
class ye {
  constructor(r) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new et(), this._blacklist = new et(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(pe.notType);
    }), this.type = r.type, this._typeCheck = r.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, r?.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(r) {
    if (this._mutate)
      return r && Object.assign(this.spec, r), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = Te(Object.assign({}, this.spec, r)), t;
  }
  label(r) {
    let t = this.clone();
    return t.spec.label = r, t;
  }
  meta(...r) {
    if (r.length === 0) return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, r[0]), t;
  }
  withMutation(r) {
    let t = this._mutate;
    this._mutate = !0;
    let s = r(this);
    return this._mutate = t, s;
  }
  concat(r) {
    if (!r || r === this) return this;
    if (r.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${r.type}`);
    let t = this, s = r.clone();
    const n = Object.assign({}, t.spec, s.spec);
    return s.spec = n, s.internalTests = Object.assign({}, t.internalTests, s.internalTests), s._whitelist = t._whitelist.merge(r._whitelist, r._blacklist), s._blacklist = t._blacklist.merge(r._blacklist, r._whitelist), s.tests = t.tests, s.exclusiveTests = t.exclusiveTests, s.withMutation((i) => {
      r.tests.forEach((a) => {
        i.test(a.OPTIONS);
      });
    }), s.transforms = [...t.transforms, ...s.transforms], s;
  }
  isType(r) {
    return r == null ? !!(this.spec.nullable && r === null || this.spec.optional && r === void 0) : this._typeCheck(r);
  }
  resolve(r) {
    let t = this;
    if (t.conditions.length) {
      let s = t.conditions;
      t = t.clone(), t.conditions = [], t = s.reduce((n, i) => i.resolve(n, r), t), t = t.resolve(r);
    }
    return t;
  }
  resolveOptions(r) {
    var t, s, n, i;
    return Object.assign({}, r, {
      from: r.from || [],
      strict: (t = r.strict) != null ? t : this.spec.strict,
      abortEarly: (s = r.abortEarly) != null ? s : this.spec.abortEarly,
      recursive: (n = r.recursive) != null ? n : this.spec.recursive,
      disableStackTrace: (i = r.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(r, t = {}) {
    let s = this.resolve(Object.assign({
      value: r
    }, t)), n = t.assert === "ignore-optionality", i = s._cast(r, t);
    if (t.assert !== !1 && !s.isType(i)) {
      if (n && us(i))
        return i;
      let a = be(r), l = be(i);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${s.type}". 

attempted value: ${a} 
` + (l !== a ? `result of cast: ${l}` : ""));
    }
    return i;
  }
  _cast(r, t) {
    let s = r === void 0 ? r : this.transforms.reduce((n, i) => i.call(this, n, r, this), r);
    return s === void 0 && (s = this.getDefault(t)), s;
  }
  _validate(r, t = {}, s, n) {
    let {
      path: i,
      originalValue: a = r,
      strict: l = this.spec.strict
    } = t, c = r;
    l || (c = this._cast(c, Object.assign({
      assert: !1
    }, t)));
    let m = [];
    for (let h of Object.values(this.internalTests))
      h && m.push(h);
    this.runTests({
      path: i,
      value: c,
      originalValue: a,
      options: t,
      tests: m
    }, s, (h) => {
      if (h.length)
        return n(h, c);
      this.runTests({
        path: i,
        value: c,
        originalValue: a,
        options: t,
        tests: this.tests
      }, s, n);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(r, t, s) {
    let n = !1, {
      tests: i,
      value: a,
      originalValue: l,
      path: c,
      options: m
    } = r, h = ($) => {
      n || (n = !0, t($, a));
    }, y = ($) => {
      n || (n = !0, s($, a));
    }, f = i.length, S = [];
    if (!f) return y([]);
    let w = {
      value: a,
      originalValue: l,
      path: c,
      options: m,
      schema: this
    };
    for (let $ = 0; $ < i.length; $++) {
      const D = i[$];
      D(w, h, function(A) {
        A && (Array.isArray(A) ? S.push(...A) : S.push(A)), --f <= 0 && y(S);
      });
    }
  }
  asNestedTest({
    key: r,
    index: t,
    parent: s,
    parentPath: n,
    originalParent: i,
    options: a
  }) {
    const l = r ?? t;
    if (l == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const c = typeof l == "number";
    let m = s[l];
    const h = Object.assign({}, a, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: s,
      value: m,
      originalValue: i[l],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [c ? "index" : "key"]: l,
      path: c || l.includes(".") ? `${n || ""}[${c ? l : `"${l}"`}]` : (n ? `${n}.` : "") + r
    });
    return (y, f, S) => this.resolve(h)._validate(m, h, f, S);
  }
  validate(r, t) {
    var s;
    let n = this.resolve(Object.assign({}, t, {
      value: r
    })), i = (s = t?.disableStackTrace) != null ? s : n.spec.disableStackTrace;
    return new Promise((a, l) => n._validate(r, t, (c, m) => {
      re.isError(c) && (c.value = m), l(c);
    }, (c, m) => {
      c.length ? l(new re(c, m, void 0, void 0, i)) : a(m);
    }));
  }
  validateSync(r, t) {
    var s;
    let n = this.resolve(Object.assign({}, t, {
      value: r
    })), i, a = (s = t?.disableStackTrace) != null ? s : n.spec.disableStackTrace;
    return n._validate(r, Object.assign({}, t, {
      sync: !0
    }), (l, c) => {
      throw re.isError(l) && (l.value = c), l;
    }, (l, c) => {
      if (l.length) throw new re(l, r, void 0, void 0, a);
      i = c;
    }), i;
  }
  isValid(r, t) {
    return this.validate(r, t).then(() => !0, (s) => {
      if (re.isError(s)) return !1;
      throw s;
    });
  }
  isValidSync(r, t) {
    try {
      return this.validateSync(r, t), !0;
    } catch (s) {
      if (re.isError(s)) return !1;
      throw s;
    }
  }
  _getDefault(r) {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this, r) : Te(t);
  }
  getDefault(r) {
    return this.resolve(r || {})._getDefault(r);
  }
  default(r) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: r
    });
  }
  strict(r = !0) {
    return this.clone({
      strict: r
    });
  }
  nullability(r, t) {
    const s = this.clone({
      nullable: r
    });
    return s.internalTests.nullable = Ee({
      message: t,
      name: "nullable",
      test(n) {
        return n === null ? this.schema.spec.nullable : !0;
      }
    }), s;
  }
  optionality(r, t) {
    const s = this.clone({
      optional: r
    });
    return s.internalTests.optionality = Ee({
      message: t,
      name: "optionality",
      test(n) {
        return n === void 0 ? this.schema.spec.optional : !0;
      }
    }), s;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(r = pe.defined) {
    return this.optionality(!1, r);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(r = pe.notNull) {
    return this.nullability(!1, r);
  }
  required(r = pe.required) {
    return this.clone().withMutation((t) => t.nonNullable(r).defined(r));
  }
  notRequired() {
    return this.clone().withMutation((r) => r.nullable().optional());
  }
  transform(r) {
    let t = this.clone();
    return t.transforms.push(r), t;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...r) {
    let t;
    if (r.length === 1 ? typeof r[0] == "function" ? t = {
      test: r[0]
    } : t = r[0] : r.length === 2 ? t = {
      name: r[0],
      test: r[1]
    } : t = {
      name: r[0],
      message: r[1],
      test: r[2]
    }, t.message === void 0 && (t.message = pe.default), typeof t.test != "function") throw new TypeError("`test` is a required parameters");
    let s = this.clone(), n = Ee(t), i = t.exclusive || t.name && s.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (s.exclusiveTests[t.name] = !!t.exclusive), s.tests = s.tests.filter((a) => !(a.OPTIONS.name === t.name && (i || a.OPTIONS.test === n.OPTIONS.test))), s.tests.push(n), s;
  }
  when(r, t) {
    !Array.isArray(r) && typeof r != "string" && (t = r, r = ".");
    let s = this.clone(), n = is(r).map((i) => new ke(i));
    return n.forEach((i) => {
      i.isSibling && s.deps.push(i.key);
    }), s.conditions.push(typeof t == "function" ? new Ke(n, t) : Ke.fromOptions(n, t)), s;
  }
  typeError(r) {
    let t = this.clone();
    return t.internalTests.typeError = Ee({
      message: r,
      name: "typeError",
      skipAbsent: !0,
      test(s) {
        return this.schema._typeCheck(s) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), t;
  }
  oneOf(r, t = pe.oneOf) {
    let s = this.clone();
    return r.forEach((n) => {
      s._whitelist.add(n), s._blacklist.delete(n);
    }), s.internalTests.whiteList = Ee({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(n) {
        let i = this.schema._whitelist, a = i.resolveAll(this.resolve);
        return a.includes(n) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        });
      }
    }), s;
  }
  notOneOf(r, t = pe.notOneOf) {
    let s = this.clone();
    return r.forEach((n) => {
      s._blacklist.add(n), s._whitelist.delete(n);
    }), s.internalTests.blacklist = Ee({
      message: t,
      name: "notOneOf",
      test(n) {
        let i = this.schema._blacklist, a = i.resolveAll(this.resolve);
        return a.includes(n) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), s;
  }
  strip(r = !0) {
    let t = this.clone();
    return t.spec.strip = r, t;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(r) {
    const t = (r ? this.resolve(r) : this).clone(), {
      label: s,
      meta: n,
      optional: i,
      nullable: a
    } = t.spec;
    return {
      meta: n,
      label: s,
      optional: i,
      nullable: a,
      default: t.getDefault(r),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((c) => ({
        name: c.OPTIONS.name,
        params: c.OPTIONS.params
      })).filter((c, m, h) => h.findIndex((y) => y.name === c.name) === m)
    };
  }
}
ye.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) ye.prototype[`${e}At`] = function(r, t, s = {}) {
  const {
    parent: n,
    parentPath: i,
    schema: a
  } = ya(this, r, t, s.context);
  return a[e](n && n[i], Object.assign({}, s, {
    parent: n,
    path: r
  }));
};
for (const e of ["equals", "is"]) ye.prototype[e] = ye.prototype.oneOf;
for (const e of ["not", "nope"]) ye.prototype[e] = ye.prototype.notOneOf;
const xa = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function ga(e) {
  const r = va(e);
  if (!r) return Date.parse ? Date.parse(e) : Number.NaN;
  if (r.z === void 0 && r.plusMinus === void 0)
    return new Date(r.year, r.month, r.day, r.hour, r.minute, r.second, r.millisecond).valueOf();
  let t = 0;
  return r.z !== "Z" && r.plusMinus !== void 0 && (t = r.hourOffset * 60 + r.minuteOffset, r.plusMinus === "+" && (t = 0 - t)), Date.UTC(r.year, r.month, r.day, r.hour, r.minute + t, r.second, r.millisecond);
}
function va(e) {
  var r, t;
  const s = xa.exec(e);
  return s ? {
    year: he(s[1]),
    month: he(s[2], 1) - 1,
    day: he(s[3], 1),
    hour: he(s[4]),
    minute: he(s[5]),
    second: he(s[6]),
    millisecond: s[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      he(s[7].substring(0, 3))
    ) : 0,
    precision: (r = (t = s[7]) == null ? void 0 : t.length) != null ? r : void 0,
    z: s[8] || void 0,
    plusMinus: s[9] || void 0,
    hourOffset: he(s[10]),
    minuteOffset: he(s[11])
  } : null;
}
function he(e, r = 0) {
  return Number(e) || r;
}
let ba = /* @__PURE__ */ new Date(""), _a = (e) => Object.prototype.toString.call(e) === "[object Date]";
class lt extends ye {
  constructor() {
    super({
      type: "date",
      check(r) {
        return _a(r) && !isNaN(r.getTime());
      }
    }), this.withMutation(() => {
      this.transform((r, t, s) => !s.spec.coerce || s.isType(r) || r === null ? r : (r = ga(r), isNaN(r) ? lt.INVALID_DATE : new Date(r)));
    });
  }
  prepareParam(r, t) {
    let s;
    if (ke.isRef(r))
      s = r;
    else {
      let n = this.cast(r);
      if (!this._typeCheck(n)) throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      s = n;
    }
    return s;
  }
  min(r, t = Ot.min) {
    let s = this.prepareParam(r, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: r
      },
      skipAbsent: !0,
      test(n) {
        return n >= this.resolve(s);
      }
    });
  }
  max(r, t = Ot.max) {
    let s = this.prepareParam(r, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: r
      },
      skipAbsent: !0,
      test(n) {
        return n <= this.resolve(s);
      }
    });
  }
}
lt.INVALID_DATE = ba;
lt.prototype;
function Sa(e, r = []) {
  let t = [], s = /* @__PURE__ */ new Set(), n = new Set(r.map(([a, l]) => `${a}-${l}`));
  function i(a, l) {
    let c = je.split(a)[0];
    s.add(c), n.has(`${l}-${c}`) || t.push([l, c]);
  }
  for (const a of Object.keys(e)) {
    let l = e[a];
    s.add(a), ke.isRef(l) && l.isSibling ? i(l.path, a) : Zt(l) && "deps" in l && l.deps.forEach((c) => i(c, a));
  }
  return sa.array(Array.from(s), t).reverse();
}
function _r(e, r) {
  let t = 1 / 0;
  return e.some((s, n) => {
    var i;
    if ((i = r.path) != null && i.includes(s))
      return t = n, !0;
  }), t;
}
function cs(e) {
  return (r, t) => _r(e, r) - _r(e, t);
}
const wa = (e, r, t) => {
  if (typeof e != "string")
    return e;
  let s = e;
  try {
    s = JSON.parse(e);
  } catch {
  }
  return t.isType(s) ? s : e;
};
function Ge(e) {
  if ("fields" in e) {
    const r = {};
    for (const [t, s] of Object.entries(e.fields))
      r[t] = Ge(s);
    return e.setFields(r);
  }
  if (e.type === "array") {
    const r = e.optional();
    return r.innerType && (r.innerType = Ge(r.innerType)), r;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Ge)
  }) : "optional" in e ? e.optional() : e;
}
const ja = (e, r) => {
  const t = [...je.normalizePath(r)];
  if (t.length === 1) return t[0] in e;
  let s = t.pop(), n = je.getter(je.join(t), !0)(e);
  return !!(n && s in n);
};
let Sr = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Fa(e, r) {
  let t = Object.keys(e.fields);
  return Object.keys(r).filter((s) => t.indexOf(s) === -1);
}
const ka = cs([]);
function ds(e) {
  return new fs(e);
}
class fs extends ye {
  constructor(r) {
    super({
      type: "object",
      check(t) {
        return Sr(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = ka, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      r && this.shape(r);
    });
  }
  _cast(r, t = {}) {
    var s;
    let n = super._cast(r, t);
    if (n === void 0) return this.getDefault(t);
    if (!this._typeCheck(n)) return n;
    let i = this.fields, a = (s = t.stripUnknown) != null ? s : this.spec.noUnknown, l = [].concat(this._nodes, Object.keys(n).filter((y) => !this._nodes.includes(y))), c = {}, m = Object.assign({}, t, {
      parent: c,
      __validating: t.__validating || !1
    }), h = !1;
    for (const y of l) {
      let f = i[y], S = y in n;
      if (f) {
        let w, $ = n[y];
        m.path = (t.path ? `${t.path}.` : "") + y, f = f.resolve({
          value: $,
          context: t.context,
          parent: c
        });
        let D = f instanceof ye ? f.spec : void 0, I = D?.strict;
        if (D != null && D.strip) {
          h = h || y in n;
          continue;
        }
        w = !t.__validating || !I ? (
          // TODO: use _cast, this is double resolving
          f.cast(n[y], m)
        ) : n[y], w !== void 0 && (c[y] = w);
      } else S && !a && (c[y] = n[y]);
      (S !== y in c || c[y] !== n[y]) && (h = !0);
    }
    return h ? c : n;
  }
  _validate(r, t = {}, s, n) {
    let {
      from: i = [],
      originalValue: a = r,
      recursive: l = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: a
    }, ...i], t.__validating = !0, t.originalValue = a, super._validate(r, t, s, (c, m) => {
      if (!l || !Sr(m)) {
        n(c, m);
        return;
      }
      a = a || m;
      let h = [];
      for (let y of this._nodes) {
        let f = this.fields[y];
        !f || ke.isRef(f) || h.push(f.asNestedTest({
          options: t,
          key: y,
          parent: m,
          parentPath: t.path,
          originalParent: a
        }));
      }
      this.runTests({
        tests: h,
        value: m,
        originalValue: a,
        options: t
      }, s, (y) => {
        n(y.sort(this._sortErrors).concat(c), m);
      });
    });
  }
  clone(r) {
    const t = super.clone(r);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(r) {
    let t = super.concat(r), s = t.fields;
    for (let [n, i] of Object.entries(this.fields)) {
      const a = s[n];
      s[n] = a === void 0 ? i : a;
    }
    return t.withMutation((n) => (
      // XXX: excludes here is wrong
      n.setFields(s, [...this._excludedEdges, ...r._excludedEdges])
    ));
  }
  _getDefault(r) {
    if ("default" in this.spec)
      return super._getDefault(r);
    if (!this._nodes.length)
      return;
    let t = {};
    return this._nodes.forEach((s) => {
      var n;
      const i = this.fields[s];
      let a = r;
      (n = a) != null && n.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[s]
      })), t[s] = i && "getDefault" in i ? i.getDefault(a) : void 0;
    }), t;
  }
  setFields(r, t) {
    let s = this.clone();
    return s.fields = r, s._nodes = Sa(r, t), s._sortErrors = cs(Object.keys(r)), t && (s._excludedEdges = t), s;
  }
  shape(r, t = []) {
    return this.clone().withMutation((s) => {
      let n = s._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), n = [...s._excludedEdges, ...t]), s.setFields(Object.assign(s.fields, r), n);
    });
  }
  partial() {
    const r = {};
    for (const [t, s] of Object.entries(this.fields))
      r[t] = "optional" in s && s.optional instanceof Function ? s.optional() : s;
    return this.setFields(r);
  }
  deepPartial() {
    return Ge(this);
  }
  pick(r) {
    const t = {};
    for (const s of r)
      this.fields[s] && (t[s] = this.fields[s]);
    return this.setFields(t, this._excludedEdges.filter(([s, n]) => r.includes(s) && r.includes(n)));
  }
  omit(r) {
    const t = [];
    for (const s of Object.keys(this.fields))
      r.includes(s) || t.push(s);
    return this.pick(t);
  }
  from(r, t, s) {
    let n = je.getter(r, !0);
    return this.transform((i) => {
      if (!i) return i;
      let a = i;
      return ja(i, r) && (a = Object.assign({}, i), s || delete a[r], a[t] = n(i)), a;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(wa);
  }
  noUnknown(r = !0, t = Dt.noUnknown) {
    typeof r != "boolean" && (t = r, r = !0);
    let s = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(n) {
        if (n == null) return !0;
        const i = Fa(this.schema, n);
        return !r || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return s.spec.noUnknown = r, s;
  }
  unknown(r = !0, t = Dt.noUnknown) {
    return this.noUnknown(!r, t);
  }
  transformKeys(r) {
    return this.transform((t) => {
      if (!t) return t;
      const s = {};
      for (const n of Object.keys(t)) s[r(n)] = t[n];
      return s;
    });
  }
  camelCase() {
    return this.transformKeys(Ft.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Ft.snakeCase);
  }
  constantCase() {
    return this.transformKeys((r) => Ft.snakeCase(r).toUpperCase());
  }
  describe(r) {
    const t = (r ? this.resolve(r) : this).clone(), s = super.describe(r);
    s.fields = {};
    for (const [i, a] of Object.entries(t.fields)) {
      var n;
      let l = r;
      (n = l) != null && n.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[i]
      })), s.fields[i] = a.describe(l);
    }
    return s;
  }
}
ds.prototype = fs.prototype;
const Aa = "e17vdvs9", kt = "e18zf2nx", Ca = /* @__PURE__ */ ae("div")({
  name: "FormContainer",
  class: "fkd0pth",
  propsAsIs: !1
}), Ea = "fny94z", Ta = () => ({
  spanSize: e = "10"
}) => e, Va = /* @__PURE__ */ ae("div")({
  name: "ChildCol",
  class: "c8v3sec",
  propsAsIs: !1,
  vars: {
    "c8v3sec-0": [Ta()]
  }
}), Oa = () => ({
  hasMarginBottom: e
}) => e ? "1.25rem" : "0", Nt = /* @__PURE__ */ ae("div")({
  name: "Listchild",
  class: "lmad8bi",
  propsAsIs: !1,
  vars: {
    "lmad8bi-0": [Oa()]
  }
}), Da = /* @__PURE__ */ ae("div")({
  name: "InputGroupWrapper",
  class: "i1nv3vip",
  propsAsIs: !1
}), tt = /* @__PURE__ */ ae("div")({
  name: "TextGap",
  class: "t1xl7jlc",
  propsAsIs: !1
}), wr = /* @__PURE__ */ ae("div")({
  name: "ButtonMargin",
  class: "bjjfdy7",
  propsAsIs: !1
}), Na = /* @__PURE__ */ ae("div")({
  name: "LineSpacerDash",
  class: "l1bkkvnf",
  propsAsIs: !1
}), $a = ({ field: e, fieldName: r, ...t }) => {
  const { register: s, getFieldState: n, formState: i } = ue(), a = n(r, i).error?.message, l = e.type === "date" ? "calendar" : e.config?.icon, c = !!e.config?.disabled;
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsx(
    _e,
    {
      label: ve(e.title, e.config?.isRequired),
      errorMessage: a,
      placeholder: e.config?.placeholder,
      inputAddOnText: e.config?.addOnText,
      type: e.type,
      icon: l,
      disabled: c,
      ...t,
      ...c ? { value: e.value?.toString() } : s(r)
    }
  ) });
}, Ra = ({ field: e, fieldName: r, ...t }) => {
  const { register: s, getFieldState: n } = ue(), i = n(r).error?.message, a = !!e.config?.disabled;
  return /* @__PURE__ */ o.jsx(
    nn,
    {
      disabled: a,
      label: ve(e.title, e.config?.isRequired),
      options: e.config?.options,
      errorMessage: i,
      ...t,
      ...a ? { value: e.value?.toString() } : s(r),
      placeholder: e.config?.placeholder
    }
  );
}, Ia = ({ fieldName: e, field: r, parentKey: t = "" }) => {
  const { setValue: s, watch: n, unregister: i } = ue(), a = n(e), l = F.useMemo(() => r.fields ? r.fields.filter((f) => f.type === "radio-button") : [], [r.fields]), c = F.useMemo(
    () => l.reduce((f, S) => !S.fields?.length ? f : [...f, S.id.toString()], []),
    [l]
  ), m = (f) => () => {
    s(e, f.value), c.forEach((S) => {
      const w = t ? `${t}.${S}` : S;
      return i(w);
    });
  }, h = (f) => a === f, y = F.useMemo(() => {
    const f = e.split("."), w = f.length - 2;
    return w < 0 ? "" : `${f[w]}.`;
  }, [e]);
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(E, { isFlexWrap: !0, isFlexColumn: !0, children: [
      r.title && /* @__PURE__ */ o.jsx(tt, { children: /* @__PURE__ */ o.jsx(U, { intent: "default", children: ve(r.title, r.config?.isRequired) }) }),
      r.description && /* @__PURE__ */ o.jsx(tt, { children: /* @__PURE__ */ o.jsx(U, { children: r.description }) }),
      /* @__PURE__ */ o.jsx(E, { className: W, isFlexWrap: !0, children: l.map((f) => /* @__PURE__ */ o.jsx(Nt, { spanSize: "1", children: /* @__PURE__ */ o.jsx(ze, { className: V(W), children: /* @__PURE__ */ o.jsx(
        _e,
        {
          disabled: r.config?.disabled,
          checked: h(f.value),
          onChange: m(f),
          label: f.title,
          type: "radio",
          name: e
        }
      ) }) }, f.id)) })
    ] }),
    l.map((f) => {
      if (!h(f.value)) return null;
      const S = `${y}${f.id}`;
      return /* @__PURE__ */ o.jsx(
        Ue,
        {
          className: Hs,
          formFields: f.fields || [],
          parentKey: S,
          parentType: f.type
        },
        S
      );
    })
  ] });
}, La = ({
  field: e,
  fieldName: r,
  collectionIndex: t,
  disableGroupSeparator: s
}) => /* @__PURE__ */ o.jsxs(E, {
  isFlexWrap: !0,
  isFlexColumn: !0,
  className: V("g1v5jfj2", Ze),
  children: [(e.title || e.description) && /* @__PURE__ */ o.jsxs(E, {
    isFlexColumn: !0,
    children: [e.title && /* @__PURE__ */ o.jsx(U, {
      hasBoldText: !0,
      children: e.title
    }), e.description && /* @__PURE__ */ o.jsx(U, {
      className: V(Tr),
      children: e.description
    })]
  }), /* @__PURE__ */ o.jsx(E, {
    className: W,
    isFlexWrap: !0,
    children: /* @__PURE__ */ o.jsx(Ue, {
      formFields: e.fields,
      parentKey: r,
      parentType: e.type,
      collectionIndex: t
    })
  }), !s && /* @__PURE__ */ o.jsx(zs, {})]
}), Pa = ({
  fieldName: e,
  field: r
}) => {
  const {
    control: t
  } = ue(), {
    fields: s,
    append: n,
    remove: i
  } = ki({
    name: e,
    control: t,
    rules: {
      required: r.config?.isRequired,
      minLength: r.config?.isRequired ? 1 : 0
    }
  }), a = r.fields?.[0], l = !!r.config?.disabled, c = async () => {
    n({});
  }, m = (h) => async () => {
    i(h);
  };
  return /* @__PURE__ */ o.jsxs(E, {
    isFlexWrap: !0,
    isFlexColumn: !0,
    children: [(r.title || r.description) && /* @__PURE__ */ o.jsxs(E, {
      isFlexColumn: !0,
      className: ar,
      children: [r.title && /* @__PURE__ */ o.jsx(U, {
        className: V(ir),
        children: r.title
      }), r.description && /* @__PURE__ */ o.jsx(U, {
        className: V(Tr),
        children: r.description
      })]
    }), /* @__PURE__ */ o.jsx(E, {
      className: W,
      isFlexWrap: !0,
      children: a && s?.map?.((h, y) => {
        const f = `${e}.${y}`, S = !!a.title, w = a.type === "group", $ = S, D = s.length > 1 && r.config?.allowAddSections;
        return /* @__PURE__ */ o.jsxs(E, {
          className: W,
          isFlexColumn: !0,
          children: [$ && /* @__PURE__ */ o.jsxs(E, {
            isFlexJustifyBetween: !0,
            className: V(W, Zs, ar),
            children: [/* @__PURE__ */ o.jsxs(U, {
              className: V(ir),
              children: [a.title, " ", y + 1]
            }), !l && D && /* @__PURE__ */ o.jsx(U, {
              onClick: m(y),
              intent: "danger",
              className: V(kt),
              children: "Remove"
            })]
          }), /* @__PURE__ */ o.jsx(Ue, {
            className: V($ && Ea),
            formFields: [{
              ...a,
              title: ""
            }],
            parentKey: f,
            parentType: r.type,
            collectionIndex: y,
            disableGroupSeparator: w && !S
          }), /* @__PURE__ */ o.jsx(E, {
            isFlexJustifyEnd: !0,
            children: !l && D && !$ && /* @__PURE__ */ o.jsx(wr, {
              children: /* @__PURE__ */ o.jsx(U, {
                onClick: m(y),
                intent: "danger",
                className: V(kt),
                children: "Remove"
              })
            })
          }), (w && !S || !w) && /* @__PURE__ */ o.jsx(Na, {})]
        }, h.id);
      })
    }), !l && r.config?.allowAddSections && a && /* @__PURE__ */ o.jsx(wr, {
      children: /* @__PURE__ */ o.jsx(We, {
        tag: "span",
        intent: "neutral",
        className: V(kt, "c18c47jf"),
        onClick: c,
        children: r.config?.addButtonText || "Add"
      })
    })]
  });
}, Ma = ({ field: e, fieldName: r, parentKey: t = "" }) => {
  const { watch: s, setValue: n, unregister: i } = ue(), a = F.useMemo(() => e.fields?.find((f) => !!f.fields?.length), []), l = s(r), c = (f) => (S) => {
    const w = S.target.checked, $ = !!f.fields?.length, D = t ? `${t}.${f.id}` : f.id.toString();
    let I = [...l];
    if (w ? I.push(f.value) : I = I.filter((A) => A !== f.value), n(r, I), !!$)
      return w ? n(D, {}) : i(D);
  }, m = (f) => l?.includes(f), h = Ar(() => e.fields ? e.fields.filter((f) => f.type === "checkbox") : [], [e.fields]), y = F.useMemo(() => {
    const f = r.split("."), w = f.length - 2;
    return w < 0 ? "" : `${f[w]}.`;
  }, [r]);
  return /* @__PURE__ */ o.jsxs(E, { isFlexWrap: !0, isFlexColumn: !0, children: [
    e.title && /* @__PURE__ */ o.jsx(tt, { children: /* @__PURE__ */ o.jsx(U, { intent: "default", children: ve(e.title, e.config?.isRequired) }) }),
    e.description && /* @__PURE__ */ o.jsx(tt, { children: /* @__PURE__ */ o.jsx(U, { children: e.description }) }),
    !a && /* @__PURE__ */ o.jsx(E, { className: V(W, Ze), isFlexWrap: !0, children: h.map((f) => {
      const S = f.id.toString(), w = f.config?.width ?? "fit-content";
      return /* @__PURE__ */ o.jsx(Nt, { spanSize: "1", style: { width: w }, children: /* @__PURE__ */ o.jsx(ze, { className: V(W), children: /* @__PURE__ */ o.jsx(
        _e,
        {
          disabled: e.config?.disabled,
          checked: m(f.value),
          onChange: c(f),
          inputAddOnText: ve(
            f.title,
            f.config?.isRequired
          ),
          type: "checkbox"
        }
      ) }) }, S);
    }) }),
    a && /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsx(E, { className: V(W, Ze), isFlexWrap: !0, children: h?.map((f) => {
      const S = `${y}${f.id}`;
      return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(Da, { className: W, children: /* @__PURE__ */ o.jsx(Nt, { spanSize: "1", children: /* @__PURE__ */ o.jsx(ze, { className: V(W), children: /* @__PURE__ */ o.jsx(
          _e,
          {
            disabled: e.config?.disabled,
            checked: m(f.value),
            onChange: c(f),
            inputAddOnText: ve(
              f.title,
              f.config?.isRequired
            ),
            type: "checkbox"
          }
        ) }) }) }, S),
        m(f.value) && /* @__PURE__ */ o.jsx(
          Ue,
          {
            formFields: f.fields,
            parentKey: S,
            parentType: f.type
          }
        )
      ] });
    }) }) })
  ] });
}, Ua = ({ field: e, fieldName: r }) => {
  const { setValue: t, getFieldState: s, formState: n } = ue(), i = s(r, n).error?.message, a = !!e.config?.isMultiple, l = !!e.config?.isRequired, c = e.value ?? [], m = c.map((f) => ({
    fileName: f.documentName,
    fileSize: f.defaultAttachmentFileSize,
    fileId: f.defaultAttachmentFileID
  })), h = c.map((f) => f.defaultAttachmentFileID), y = (f) => {
    if (!f) {
      t(r, []), t(Xe, void 0);
      return;
    }
    const w = (Array.isArray(f) ? f : [f]).map((D) => ({
      defaultAttachmentFileID: D.fileId || "",
      defaultAttachmentFileSize: D.fileSize,
      documentName: D.fileName
    })), $ = w.reduce((D, I) => h.includes(I.defaultAttachmentFileID) ? D : [...D, I.defaultAttachmentFileID], []);
    t(r, w), t(Xe, $);
  };
  return /* @__PURE__ */ o.jsx(
    an,
    {
      onChange: y,
      allowMultiple: a,
      label: e.title,
      required: l,
      errorMessage: i,
      acceptedFileType: "agreement/attachment",
      maximumFileSize: "4 mb",
      disableDeleteActualFile: !0,
      defaultData: m
    }
  );
}, Ba = ({ field: e, fieldName: r, ...t }) => {
  const { register: s, formState: n, getFieldState: i, setValue: a } = ue(), l = i(r, n).error?.message, c = e.config?.currency;
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsx(
    _e,
    {
      ...t,
      ...s(r),
      onBlur: (m) => {
        const h = m.target.value;
        a(r, Number(h).toFixed(2));
      },
      errorMessage: l,
      label: ve(e.title, e.config?.isRequired),
      type: "text",
      icon: c || "dollarSystem",
      disabled: e.config?.disabled,
      min: 2,
      max: 3,
      ...on(/^[0-9]\.*$/)
    }
  ) });
}, qa = ({ field: e, fieldName: r }) => {
  const { register: t, formState: s, getFieldState: n } = ue(), i = n(r, s).error?.message, a = !!e.config?.disabled;
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsxs(_e, { children: [
    /* @__PURE__ */ o.jsx(
      Xs,
      {
        disabled: a,
        placeholder: e.config?.placeholder,
        type: "text",
        hasError: !!i,
        ...a ? { value: e.value?.toString() } : t(r)
      }
    ),
    /* @__PURE__ */ o.jsx(rt, { children: ve(e.title, e.config?.isRequired) }),
    i && /* @__PURE__ */ o.jsx(Rt, { message: i })
  ] }) });
}, Ga = (e) => {
  const { field: r } = e, t = [
    "text",
    "email",
    "password",
    "number",
    "tel",
    "url",
    "search",
    "date",
    "time",
    "datetime-local",
    "week"
  ];
  switch (r.type) {
    case "attachment":
      return /* @__PURE__ */ o.jsx(Ua, { ...e });
    case "checkbox-group":
      return /* @__PURE__ */ o.jsx(Ma, { ...e });
    case "collection":
      return /* @__PURE__ */ o.jsx(Pa, { ...e });
    case "currency":
      return /* @__PURE__ */ o.jsx(Ba, { ...e });
    case "group":
      return /* @__PURE__ */ o.jsx(La, { ...e });
    case "radio-group":
      return /* @__PURE__ */ o.jsx(Ia, { ...e });
    case "select":
      return /* @__PURE__ */ o.jsx(Ra, { ...e });
    case "text-area":
      return /* @__PURE__ */ o.jsx(qa, { ...e });
    default:
      return t.includes(r.type) ? /* @__PURE__ */ o.jsx($a, { ...e }) : null;
  }
}, Wa = F.memo(
  ({ field: e, fieldKey: r, spanSize: t, shouldHideBasedOnDependency: s, collectionIndex: n, parentKey: i, disableGroupSeparator: a }) => {
    const { getValues: l, setValue: c } = ue(), m = F.useRef(), h = l(r);
    if (n !== 0 && e.config?.showOnlyForFirstGroup) return;
    const y = m.current;
    return F.useEffect(() => {
      !s || !h || (m.current = h, c(r, void 0));
    }, [s, h]), F.useEffect(() => {
      s || !y || (m.current = void 0, c(r, y));
    }, [s, y]), s ? null : /* @__PURE__ */ o.jsx(Va, { spanSize: t, children: /* @__PURE__ */ o.jsx(ze, { className: V(W), children: /* @__PURE__ */ o.jsx(
      Ga,
      {
        field: e,
        fieldName: r,
        parentKey: i,
        collectionIndex: n,
        disableGroupSeparator: a
      },
      r
    ) }) }, r);
  }
), Ue = ({
  className: e,
  formFields: r,
  parentType: t,
  ...s
}) => {
  const { watch: n } = ue();
  return !r || r.length === 0 ? null : /* @__PURE__ */ o.jsx(Ca, { className: V(e, Aa), children: r.map((i) => {
    let a = i.id.toString(), l = i.config?.dependencyKey;
    const c = i.config?.dependencyValue, m = t !== "collection" && typeof l < "u" && typeof c < "u", h = i.config?.width || "100%", y = Math.round(parseInt(h.match(/\d+/)?.[0] || "0", 10) / 10).toString();
    s.parentKey && (a = t === "collection" ? s.parentKey : `${s.parentKey}.${a}`, l = m ? `${s.parentKey}.${l}` : void 0);
    const f = !!(m && l && n(l) !== c);
    return /* @__PURE__ */ o.jsx(
      Wa,
      {
        field: i,
        ...s,
        spanSize: y,
        dependencyKey: l,
        dependencyValue: c,
        fieldKey: a,
        shouldHideBasedOnDependency: f
      },
      i.id
    );
  }) });
}, Ha = ({
  field: e,
  fieldKey: r,
  parentKey: t,
  parentType: s
}) => {
  let n = {}, i = {};
  if (s !== "checkbox-group" || !t)
    return console.error("err: checkbox can only rendered inside checkbox-group"), { defaultValue: n, validationSchema: i };
  const a = e.fields ?? [];
  if (!(a.length > 0)) return { defaultValue: n, validationSchema: i };
  const c = Ae(a);
  return n = { [r]: c.defaultValue }, i = {
    [r]: oe.object(c.validationSchema).when(t, {
      is: (m) => m?.includes(r) || typeof e.value == "string" && m?.includes(e.value),
      then: (m) => m.required(),
      otherwise: (m) => m.notRequired().nullable().optional().default(void 0)
    })
  }, { defaultValue: n, validationSchema: i };
}, za = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  const n = e.fields || [], i = e.value;
  let a = { [r]: e.value || [] }, l = {};
  if (!(n.length > 0)) return { defaultValue: a, validationSchema: l };
  const c = {
    [r]: oe.array().applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (y) => y.min(1, t).required(t).typeError(t)
    )
  }, m = Ae(n, r, e.type), h = n.reduce((y, f) => {
    const S = f.id.toString(), w = f.value?.toString() ?? "";
    return i.includes(w) ? { ...y, [S]: m.defaultValue[S] } : y;
  }, {});
  return a = {
    ...a,
    ...h
  }, c[r] = c[r].minItems(e.config?.min).maxItems(e.config?.max), l = { ...c, ...m.validationSchema }, { defaultValue: a, validationSchema: l };
}, Za = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  let n = {}, i = {};
  const a = e.fields ?? [];
  if (!a[0]) return { defaultValue: n, validationSchema: i };
  const c = a.reduce(
    (m, h) => {
      const y = h.id, f = Ae([h]), S = f.defaultValue[y], w = f.validationSchema[y];
      return {
        defaultValue: [...m.defaultValue, S],
        validationSchema: w
      };
    },
    { defaultValue: [] }
  );
  return n = { [r]: c.defaultValue }, i = {
    [r]: oe.array(c.validationSchema).applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (m) => m.min(e.config?.min ?? 1, t).required(t).typeError(t)
    )
  }, i[r] = i[r].minItems(e.config?.min).maxItems(e.config?.max), { defaultValue: n, validationSchema: i };
}, Xa = ({ field: e, fieldKey: r, parentKey: t, parentType: s }) => {
  let n = {}, i = {};
  if (s !== "radio-group" || !t)
    return console.error("err: radio-buttin can only rendered inside radio-group"), { defaultValue: n, validationSchema: i };
  const a = e.fields ?? [];
  if (!(a.length > 0)) return { defaultValue: n, validationSchema: i };
  const c = Ae(a);
  return n = { [r]: c.defaultValue }, i = {
    [r]: oe.object(c.validationSchema).when(t, {
      is: (m) => m === r || typeof e.value == "string" && m === e.value,
      then: (m) => m.required(),
      otherwise: (m) => m.notRequired().nullable().optional().default(void 0)
    })
  }, { defaultValue: n, validationSchema: i };
}, Ya = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  const n = e.fields, i = e.value;
  let a = { [r]: e.value ?? "" }, l = {};
  if (!n) return { defaultValue: a, validationSchema: l };
  l = {
    [r]: oe.string().applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (h) => h.min(1, t).required(t).typeError(t)
    )
  };
  const c = Ae(n, r, e.type), m = n.reduce((h, y) => {
    const f = y.id.toString(), S = y.value?.toString() ?? "";
    return i.includes(S) ? { ...h, [f]: c.defaultValue[f] } : h;
  }, {});
  return a = {
    ...a,
    ...m
  }, l = { ...l, ...c.validationSchema }, { defaultValue: a, validationSchema: l };
}, Ja = ({ field: e, fieldKey: r }) => {
  let t = {}, s = {};
  const n = e.fields || [];
  if (!(n.length > 0)) return { defaultValue: t, validationSchema: s };
  const i = Ae(n);
  return t = { [r]: i.defaultValue }, s = {
    [r]: oe.object(i.validationSchema)
  }, { defaultValue: t, validationSchema: s };
}, Qa = ["currency", "number"], Ka = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  const n = { [r]: e.value ?? "" }, i = {
    [r]: oe.string().applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (c) => c.required(t).typeError(t)
    )
  };
  switch (e.config?.expectedDataPattern) {
    case "bankAccountNumber":
      i[r] = i[r].bankAccountNumber();
      break;
    case "bpayNumber":
      i[r] = i[r].bpayBillerCode();
      break;
    case "bsbNumber":
      i[r] = i[r].bsbNumber();
      break;
    case "email":
      i[r] = i[r].email();
      break;
    case "facsimile":
      i[r] = i[r].facsimile();
      break;
    case "mobile":
      i[r] = i[r].mobileNumber();
      break;
    case "multipleEmail":
      i[r] = i[r].multipleEmail();
      break;
    case "phone":
      i[r] = i[r].phoneNumber();
      break;
  }
  const a = e.config?.expectedDataPattern === "multipleEmail";
  return Qa.includes(e.type) ? i[r] = i[r].minNumber(e.config?.min).maxNumber(e.config?.max) : i[r] = i[r].minLength(e.config?.min, a ? (c) => c.split(",") : void 0).maxLength(e.config?.max, a ? (c) => c.split(",") : void 0), { defaultValue: n, validationSchema: i };
}, el = ({ field: e, fieldKey: r, errorMessage: t, isRequired: s }) => {
  const n = { [r]: e.value ?? "" }, i = {
    [r]: oe.date().applyDependency(
      s,
      e.config?.dependencyKey,
      e.config?.dependencyValue,
      (c) => c.required(t).typeError(t)
    )
  }, a = e.config?.min, l = e.config?.min;
  return i[r] = i[r].min(a ? new Date(a) : void 0).max(l ? new Date(l) : void 0), { defaultValue: n, validationSchema: i };
}, tl = (e, r, t) => {
  const s = e.type, n = e.id.toString(), i = e.config?.errorMessages || `${e.title} is required.`, a = !!(e.config?.isRequired && !e.config?.disabled), l = { errorMessage: i, field: e, fieldKey: n, isRequired: a };
  switch (s) {
    case "attachment":
      return fi(l);
    case "checkbox":
      return Ha({ ...l, parentKey: r, parentType: t });
    case "checkbox-group":
      return za(l);
    case "collection":
      return Za(l);
    case "radio-button":
      return Xa({ ...l, parentKey: r, parentType: t });
    case "radio-group":
      return Ya(l);
    case "group":
      return Ja(l);
    case "date":
      return el(l);
    default:
      return Ka(l);
  }
}, Ae = (e, r, t) => {
  let s = {}, n = {};
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (!a) continue;
    const l = tl(a, r, t);
    s = { ...s, ...l.defaultValue }, n = { ...n, ...l.validationSchema };
  }
  return { defaultValue: s, validationSchema: n };
}, rl = ({ className: e, formFields: r, onSubmit: t, onClose: s, isLoading: n }) => {
  const i = Ar(() => Ae(r), []), a = $i({
    defaultValues: i.defaultValue,
    resolver: Li(ds(i.validationSchema))
  }), l = async (c) => {
    t?.(c);
  };
  return /* @__PURE__ */ o.jsx(vi, { ...a, children: /* @__PURE__ */ o.jsxs(
    "form",
    {
      onSubmit: a.handleSubmit(l),
      className: V(Ys, Js, Ze, $t, e),
      children: [
        /* @__PURE__ */ o.jsx(Ue, { formFields: r }),
        /* @__PURE__ */ o.jsxs(Er, { alignment: "right", className: W, children: [
          /* @__PURE__ */ o.jsx(He, { intent: "neutral", onClick: s, disabled: n, type: "button", children: "Cancel" }),
          /* @__PURE__ */ o.jsx(He, { disabled: n, loading: n, intent: "primary", type: "submit", children: "Save" })
        ] })
      ]
    }
  ) });
}, sl = ({ changeRequest: e, ...r }) => {
  const { data: t, isSubmitting: s, saveForm: n } = hi(), i = async (l) => {
    s || (await n(l), r.onClose?.());
  }, a = !!e?.length;
  return /* @__PURE__ */ o.jsxs(st, { children: [
    a && /* @__PURE__ */ o.jsx(ri, { changesRequested: e }),
    /* @__PURE__ */ o.jsx(
      rl,
      {
        formFields: t ?? [],
        onSubmit: i,
        onClose: r.onClose,
        isLoading: s
      }
    )
  ] });
}, nl = (e) => /* @__PURE__ */ o.jsx(st, { children: /* @__PURE__ */ o.jsx(pi, { id: e.id, documentId: e.documentId, children: /* @__PURE__ */ o.jsx(sl, { ...e }) }) });
var il = jr.createContext(
  void 0
), al = ({
  client: e,
  children: r
}) => (jr.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ o.jsx(il.Provider, { value: e, children: r }));
const ll = /* @__PURE__ */ ae("div")({
  name: "RefWrapper",
  class: "rv3hodt",
  propsAsIs: !1
}), Tl = ({
  section: e,
  documentId: r,
  onLoaded: t,
  onEditStateChange: s,
  isEditing: n,
  changeRequest: i,
  orbserver: a
}) => {
  const l = F.useRef(null), { sectionId: c } = Ks();
  F.useEffect(() => {
    c == e.id && l.current && l.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }, [c]), F.useEffect(() => {
    if (!a) return;
    const h = setTimeout(() => {
      l.current && a.observe(l.current);
    }, 500);
    return () => {
      clearTimeout(h), l.current && a.unobserve(l.current);
    };
  }, [l.current, a]);
  const m = e.isEditable && !n;
  return /* @__PURE__ */ o.jsxs(al, { client: un, children: [
    /* @__PURE__ */ o.jsx(ll, { ref: l, id: e.id }),
    /* @__PURE__ */ o.jsx(
      Un,
      {
        title: e.title,
        iconName: e.icon,
        actionTitle: m ? "Edit" : "",
        onActionClick: () => m && s?.(!0, e.id),
        children: n ? /* @__PURE__ */ o.jsx(
          nl,
          {
            changeRequest: i,
            onClose: () => s?.(!1),
            ...e,
            documentId: r
          }
        ) : /* @__PURE__ */ o.jsx(di, { changeRequest: i, ...e, documentId: r, onLoaded: t })
      }
    )
  ] });
};
export {
  ei as CHANGE_REQUEST_LIST_ITEM_CLASSNAME,
  Tl as CardsSection,
  ri as ChangeRequestedDetailedList,
  Kn as ChangeRequestedListItem,
  Qn as ChangeRequestedWarningMessage,
  qn as DisplayInputValue,
  Mr as DisplayTextSignatureValue,
  Nn as Divider,
  rl as DynamicForm,
  Jn as EmptyRequiredFieldCount,
  kl as InputTextSignature,
  vl as MainLayout,
  wl as PageContent,
  bl as PageInformationContent,
  _l as PageInformationDivider,
  Sl as PageInformationList,
  jl as PageLayout,
  Fl as SecondaryLayout,
  El as SecondaryNavigation,
  Un as SectionTile,
  Al as SelectCountry,
  Cl as SelectRegions
};
